import { useEffect, useState } from "react";
import { AnaliticasCreate } from "./AnaliticasCreate";
import { useLoaderData, useParams } from "react-router-dom";
import { FileUploader } from "./FileUploader";

export function AnaliticasNew(props) {
  const analiticas = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const [warningMessages, setWarningMessages] = useState([]);
  const [warningSecondMessages, setWarningSecondMessages] = useState([]);
  const [warningGeneralMessages, setWarningGeneralMessages] = useState([]);

  const [analiticaIsSecond, setAnaliticaIsSecond] = useState(false);

  const [isNotJson, setIsNotJson] = useState(false);

  const [analiFile, setAnaliFile] = useState("");
  console.log(analiFile);

  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  // Variables del formulario
  const [analiFecha, setAnaliFecha] = useState(todayDate);
  const [analiFechaAnali, setAnaliFechaAnali] = useState("");
  const [analiName, setAnaliName] = useState("");
  const [analiSurname, setAnaliSurname] = useState("");
  const [analiDni, setAnaliDni] = useState("");
  const [analiNhc, setAnaliNhc] = useState("");
  const [analiBed, setAnaliBed] = useState("");
  const [analiSex, setAnaliSex] = useState("");
  const [analiOrigen, setAnaliOrigen] = useState("");
  const [analiDoctor, setAnaliDoctor] = useState("");
  const [analiObs, setAnaliObs] = useState("");
  const [analiticaJson, setAnaliticaJson] = useState({});

  // Función para calcular los limites y resultados de las analiticas
  const calculateResultProperties = (result, low, high) => {
    const color =
      result >= low && result <= high
        ? "anali-result-good"
        : "anali-result-bad";
    const markIn = Math.min(
      Math.max(((result - low) / (high - low)) * 100, 0),
      100
    ).toFixed(0);
    const markOut =
      result < low
        ? "anali-result-low"
        : result > high
        ? "anali-result-high"
        : "";

    return { color, markIn, markOut };
  };

  // Hematies
  const [analiHematiesResult, setAnaliHematiesResult] = useState(undefined);
  const [analiHematiesLow, setAnaliHematiesLow] = useState(undefined);
  const [analiHematiesHigh, setAnaliHematiesHigh] = useState(undefined);
  const {
    color: analiHematiesColor,
    markIn: analiHematiesMarkIn,
    markOut: analiHematiesMarkOut,
  } = calculateResultProperties(
    analiHematiesResult,
    analiHematiesLow,
    analiHematiesHigh
  );

  // Hemoglobina
  const [analiHemoglobResult, setAnaliHemoglobResult] = useState(undefined);
  const [analiHemoglobLow, setAnaliHemoglobLow] = useState(undefined);
  const [analiHemoglobHigh, setAnaliHemoglobHigh] = useState(undefined);
  const {
    color: analiHemoglobColor,
    markIn: analiHemoglobMarkIn,
    markOut: analiHemoglobMarkOut,
  } = calculateResultProperties(
    analiHemoglobResult,
    analiHemoglobLow,
    analiHemoglobHigh
  );

  // Hematocrito
  const [analiHematcrResult, setAnaliHematcrResult] = useState(undefined);
  const [analiHematcrLow, setAnaliHematcrLow] = useState(undefined);
  const [analiHematcrHigh, setAnaliHematcrHigh] = useState(undefined);
  const {
    color: analiHematcrColor,
    markIn: analiHematcrMarkIn,
    markOut: analiHematcrMarkOut,
  } = calculateResultProperties(
    analiHematcrResult,
    analiHematcrLow,
    analiHematcrHigh
  );

  // VCM
  const [analiVcmResult, setAnaliVcmResult] = useState(undefined);
  const [analiVcmLow, setAnaliVcmLow] = useState(undefined);
  const [analiVcmHigh, setAnaliVcmHigh] = useState(undefined);
  const {
    color: analiVcmColor,
    markIn: analiVcmMarkIn,
    markOut: analiVcmMarkOut,
  } = calculateResultProperties(analiVcmResult, analiVcmLow, analiVcmHigh);

  // HCM
  const [analiHcmResult, setAnaliHcmResult] = useState(undefined);
  const [analiHcmLow, setAnaliHcmLow] = useState(undefined);
  const [analiHcmHigh, setAnaliHcmHigh] = useState(undefined);
  const {
    color: analiHcmColor,
    markIn: analiHcmMarkIn,
    markOut: analiHcmMarkOut,
  } = calculateResultProperties(analiHcmResult, analiHcmLow, analiHcmHigh);

  // CHCM
  const [analiChcmResult, setAnaliChcmResult] = useState(undefined);
  const [analiChcmLow, setAnaliChcmLow] = useState(undefined);
  const [analiChcmHigh, setAnaliChcmHigh] = useState(undefined);
  const {
    color: analiChcmColor,
    markIn: analiChcmMarkIn,
    markOut: analiChcmMarkOut,
  } = calculateResultProperties(analiChcmResult, analiChcmLow, analiChcmHigh);

  // IDH
  const [analiIdhResult, setAnaliIdhResult] = useState(undefined);
  const [analiIdhLow, setAnaliIdhLow] = useState(undefined);
  const [analiIdhHigh, setAnaliIdhHigh] = useState(undefined);
  const {
    color: analiIdhColor,
    markIn: analiIdhMarkIn,
    markOut: analiIdhMarkOut,
  } = calculateResultProperties(analiIdhResult, analiIdhLow, analiIdhHigh);

  // Leucocitos
  const [analiLeucoResult, setAnaliLeucoResult] = useState(undefined);
  const [analiLeucoLow, setAnaliLeucoLow] = useState(undefined);
  const [analiLeucoHigh, setAnaliLeucoHigh] = useState(undefined);
  const {
    color: analiLeucoColor,
    markIn: analiLeucoMarkIn,
    markOut: analiLeucoMarkOut,
  } = calculateResultProperties(
    analiLeucoResult,
    analiLeucoLow,
    analiLeucoHigh
  );

  // Neutrófilos segmentados
  const [analiNeutrResult, setAnaliNeutrResult] = useState(undefined);
  const [analiNeutrLow, setAnaliNeutrLow] = useState(undefined);
  const [analiNeutrHigh, setAnaliNeutrHigh] = useState(undefined);
  const {
    color: analiNeutrColor,
    markIn: analiNeutrMarkIn,
    markOut: analiNeutrMarkOut,
  } = calculateResultProperties(
    analiNeutrResult,
    analiNeutrLow,
    analiNeutrHigh
  );

  // Linfocitos
  const [analiLinfoResult, setAnaliLinfoResult] = useState(undefined);
  const [analiLinfoLow, setAnaliLinfoLow] = useState(undefined);
  const [analiLinfoHigh, setAnaliLinfoHigh] = useState(undefined);
  const {
    color: analiLinfoColor,
    markIn: analiLinfoMarkIn,
    markOut: analiLinfoMarkOut,
  } = calculateResultProperties(
    analiLinfoResult,
    analiLinfoLow,
    analiLinfoHigh
  );

  // Monocitos
  const [analiMonocResult, setAnaliMonocResult] = useState(undefined);
  const [analiMonocLow, setAnaliMonocLow] = useState(undefined);
  const [analiMonocHigh, setAnaliMonocHigh] = useState(undefined);
  const {
    color: analiMonocColor,
    markIn: analiMonocMarkIn,
    markOut: analiMonocMarkOut,
  } = calculateResultProperties(
    analiMonocResult,
    analiMonocLow,
    analiMonocHigh
  );

  // Eosinófilos
  const [analiEosinResult, setAnaliEosinResult] = useState(undefined);
  const [analiEosinLow, setAnaliEosinLow] = useState(undefined);
  const [analiEosinHigh, setAnaliEosinHigh] = useState(undefined);
  const {
    color: analiEosinColor,
    markIn: analiEosinMarkIn,
    markOut: analiEosinMarkOut,
  } = calculateResultProperties(
    analiEosinResult,
    analiEosinLow,
    analiEosinHigh
  );

  // Basófilos
  const [analiBasofResult, setAnaliBasofResult] = useState(undefined);
  const [analiBasofLow, setAnaliBasofLow] = useState(undefined);
  const [analiBasofHigh, setAnaliBasofHigh] = useState(undefined);
  const {
    color: analiBasofColor,
    markIn: analiBasofMarkIn,
    markOut: analiBasofMarkOut,
  } = calculateResultProperties(
    analiBasofResult,
    analiBasofLow,
    analiBasofHigh
  );

  // Plaquetas
  const [analiPlaqResult, setAnaliPlaqResult] = useState(undefined);
  const [analiPlaqLow, setAnaliPlaqLow] = useState(undefined);
  const [analiPlaqHigh, setAnaliPlaqHigh] = useState(undefined);
  const {
    color: analiPlaqColor,
    markIn: analiPlaqMarkIn,
    markOut: analiPlaqMarkOut,
  } = calculateResultProperties(analiPlaqResult, analiPlaqLow, analiPlaqHigh);

  // PCT
  const [analiPctResult, setAnaliPctResult] = useState(undefined);
  const [analiPctLow, setAnaliPctLow] = useState(undefined);
  const [analiPctHigh, setAnaliPctHigh] = useState(undefined);
  const {
    color: analiPctColor,
    markIn: analiPctMarkIn,
    markOut: analiPctMarkOut,
  } = calculateResultProperties(analiPctResult, analiPctLow, analiPctHigh);

  // VPM
  const [analiVpmResult, setAnaliVpmResult] = useState(undefined);
  const [analiVpmLow, setAnaliVpmLow] = useState(undefined);
  const [analiVpmHigh, setAnaliVpmHigh] = useState(undefined);
  const {
    color: analiVpmColor,
    markIn: analiVpmMarkIn,
    markOut: analiVpmMarkOut,
  } = calculateResultProperties(analiVpmResult, analiVpmLow, analiVpmHigh);

  // IDP
  const [analiIdpResult, setAnaliIdpResult] = useState(undefined);
  const [analiIdpLow, setAnaliIdpLow] = useState(undefined);
  const [analiIdpHigh, setAnaliIdpHigh] = useState(undefined);
  const {
    color: analiIdpColor,
    markIn: analiIdpMarkIn,
    markOut: analiIdpMarkOut,
  } = calculateResultProperties(analiIdpResult, analiIdpLow, analiIdpHigh);

  // Tiempo de Protrombina (seg)
  const [analiTieProtResult, setAnaliTieProtResult] = useState(undefined);
  const [analiTieProtLow, setAnaliTieProtLow] = useState(undefined);
  const [analiTieProtHigh, setAnaliTieProtHigh] = useState(undefined);
  const {
    color: analiTieProtColor,
    markIn: analiTieProtMarkIn,
    markOut: analiTieProtMarkOut,
  } = calculateResultProperties(
    analiTieProtResult,
    analiTieProtLow,
    analiTieProtHigh
  );

  // Actividad de Protrombina (%)
  const [analiActProtResult, setAnaliActProtResult] = useState(undefined);
  const [analiActProtLow, setAnaliActProtLow] = useState(undefined);
  const [analiActProtHigh, setAnaliActProtHigh] = useState(undefined);
  const {
    color: analiActProtColor,
    markIn: analiActProtMarkIn,
    markOut: analiActProtMarkOut,
  } = calculateResultProperties(
    analiActProtResult,
    analiActProtLow,
    analiActProtHigh
  );

  // INR
  const [analiInrResult, setAnaliInrResult] = useState(undefined);
  const [analiInrLow, setAnaliInrLow] = useState(undefined);
  const [analiInrHigh, setAnaliInrHigh] = useState(undefined);
  const {
    color: analiInrColor,
    markIn: analiInrMarkIn,
    markOut: analiInrMarkOut,
  } = calculateResultProperties(analiInrResult, analiInrLow, analiInrHigh);

  // Glucosa, Suero/Pl
  const [analiGlucResult, setAnaliGlucResult] = useState(undefined);
  const [analiGlucLow, setAnaliGlucLow] = useState(undefined);
  const [analiGlucHigh, setAnaliGlucHigh] = useState(undefined);
  const {
    color: analiGlucColor,
    markIn: analiGlucMarkIn,
    markOut: analiGlucMarkOut,
  } = calculateResultProperties(analiGlucResult, analiGlucLow, analiGlucHigh);

  // Urea, Suero/Pl
  const [analiUreaResult, setAnaliUreaResult] = useState(undefined);
  const [analiUreaLow, setAnaliUreaLow] = useState(undefined);
  const [analiUreaHigh, setAnaliUreaHigh] = useState(undefined);
  const {
    color: analiUreaColor,
    markIn: analiUreaMarkIn,
    markOut: analiUreaMarkOut,
  } = calculateResultProperties(analiUreaResult, analiUreaLow, analiUreaHigh);

  // Creatinina, Suero/Pl
  const [analiCreatResult, setAnaliCreatResult] = useState(undefined);
  const [analiCreatLow, setAnaliCreatLow] = useState(undefined);
  const [analiCreatHigh, setAnaliCreatHigh] = useState(undefined);
  const {
    color: analiCreatColor,
    markIn: analiCreatMarkIn,
    markOut: analiCreatMarkOut,
  } = calculateResultProperties(
    analiCreatResult,
    analiCreatLow,
    analiCreatHigh
  );

  // Filtrado Glomerular CKD-EPI
  const [analiGlomResult, setAnaliGlomResult] = useState(undefined);
  const [analiGlomLow, setAnaliGlomLow] = useState(undefined);
  const [analiGlomHigh, setAnaliGlomHigh] = useState(undefined);
  const {
    color: analiGlomColor,
    markIn: analiGlomMarkIn,
    markOut: analiGlomMarkOut,
  } = calculateResultProperties(analiGlomResult, analiGlomLow, analiGlomHigh);

  // Aspartato Amino Transferasa (AST/GOT), Suero/Pl
  const [analiAsparResult, setAnaliAsparResult] = useState(undefined);
  const [analiAsparLow, setAnaliAsparLow] = useState(undefined);
  const [analiAsparHigh, setAnaliAsparHigh] = useState(undefined);
  const {
    color: analiAsparColor,
    markIn: analiAsparMarkIn,
    markOut: analiAsparMarkOut,
  } = calculateResultProperties(
    analiAsparResult,
    analiAsparLow,
    analiAsparHigh
  );

  // Alanina Amino Transferasa (ALT/GPT), Suero/Pl
  const [analiAlanResult, setAnaliAlanResult] = useState(undefined);
  const [analiAlanLow, setAnaliAlanLow] = useState(undefined);
  const [analiAlanHigh, setAnaliAlanHigh] = useState(undefined);
  const {
    color: analiAlanColor,
    markIn: analiAlanMarkIn,
    markOut: analiAlanMarkOut,
  } = calculateResultProperties(analiAlanResult, analiAlanLow, analiAlanHigh);

  // Gamma Glutamil Transferasa (GGT), Suero/Pl

  const [analiGammResult, setAnaliGammResult] = useState(undefined);
  const [analiGammLow, setAnaliGammLow] = useState(undefined);
  const [analiGammHigh, setAnaliGammHigh] = useState(undefined);
  const {
    color: analiGammColor,
    markIn: analiGammMarkIn,
    markOut: analiGammMarkOut,
  } = calculateResultProperties(analiGammResult, analiGammLow, analiGammHigh);

  // Fosfatasa Alcalina (FA), Suero/Pl
  const [analiFosfResult, setAnaliFosfResult] = useState(undefined);
  const [analiFosfLow, setAnaliFosfLow] = useState(undefined);
  const [analiFosfHigh, setAnaliFosfHigh] = useState(undefined);
  const {
    color: analiFosfColor,
    markIn: analiFosfMarkIn,
    markOut: analiFosfMarkOut,
  } = calculateResultProperties(analiFosfResult, analiFosfLow, analiFosfHigh);

  // Bilirrubina total, Suero/Pl
  const [analiBiliResult, setAnaliBiliResult] = useState(undefined);
  const [analiBiliLow, setAnaliBiliLow] = useState(undefined);
  const [analiBiliHigh, setAnaliBiliHigh] = useState(undefined);
  const {
    color: analiBiliColor,
    markIn: analiBiliMarkIn,
    markOut: analiBiliMarkOut,
  } = calculateResultProperties(analiBiliResult, analiBiliLow, analiBiliHigh);

  // Colesterol, Suero/Pl
  const [analiColestResult, setAnaliColestResult] = useState(undefined);
  const [analiColestLow, setAnaliColestLow] = useState(undefined);
  const [analiColestHigh, setAnaliColestHigh] = useState(undefined);
  const {
    color: analiColestColor,
    markIn: analiColestMarkIn,
    markOut: analiColestMarkOut,
  } = calculateResultProperties(
    analiColestResult,
    analiColestLow,
    analiColestHigh
  );

  // Colesterol HDL, Suero/Pl
  const [analiColestHdlResult, setAnaliColestHdlResult] = useState(undefined);
  const [analiColestHdlLow, setAnaliColestHdlLow] = useState(undefined);
  const [analiColestHdlHigh, setAnaliColestHdlHigh] = useState(undefined);
  const {
    color: analiColestHdlColor,
    markIn: analiColestHdlMarkIn,
    markOut: analiColestHdlMarkOut,
  } = calculateResultProperties(
    analiColestHdlResult,
    analiColestHdlLow,
    analiColestHdlHigh
  );

  // Colesterol LDL, Suero/Pl
  const [analiColestLdlResult, setAnaliColestLdlResult] = useState(undefined);
  const [analiColestLdlLow, setAnaliColestLdlLow] = useState(undefined);
  const [analiColestLdlHigh, setAnaliColestLdlHigh] = useState(undefined);
  const {
    color: analiColestLdlColor,
    markIn: analiColestLdlMarkIn,
    markOut: analiColestLdlMarkOut,
  } = calculateResultProperties(
    analiColestLdlResult,
    analiColestLdlLow,
    analiColestLdlHigh
  );

  // Triglicéridos, Suero/Pl
  const [analiTriglResult, setAnaliTriglResult] = useState(undefined);
  const [analiTriglLow, setAnaliTriglLow] = useState(undefined);
  const [analiTriglHigh, setAnaliTriglHigh] = useState(undefined);
  const {
    color: analiTriglColor,
    markIn: analiTriglMarkIn,
    markOut: analiTriglMarkOut,
  } = calculateResultProperties(
    analiTriglResult,
    analiTriglLow,
    analiTriglHigh
  );

  // Calcio, Suero/Pl
  const [analiCalcResult, setAnaliCalcResult] = useState(undefined);
  const [analiCalcLow, setAnaliCalcLow] = useState(undefined);
  const [analiCalcHigh, setAnaliCalcHigh] = useState(undefined);
  const {
    color: analiCalcColor,
    markIn: analiCalcMarkIn,
    markOut: analiCalcMarkOut,
  } = calculateResultProperties(analiCalcResult, analiCalcLow, analiCalcHigh);

  // Hierro, Suero/Pl
  const [analiHierrResult, setAnaliHierrResult] = useState(undefined);
  const [analiHierrLow, setAnaliHierrLow] = useState(undefined);
  const [analiHierrHigh, setAnaliHierrHigh] = useState(undefined);
  const {
    color: analiHierrColor,
    markIn: analiHierrMarkIn,
    markOut: analiHierrMarkOut,
  } = calculateResultProperties(
    analiHierrResult,
    analiHierrLow,
    analiHierrHigh
  );

  // Sodio, Suero/Pl
  const [analiSodResult, setAnaliSodResult] = useState(undefined);
  const [analiSodLow, setAnaliSodLow] = useState(undefined);
  const [analiSodHigh, setAnaliSodHigh] = useState(undefined);
  const {
    color: analiSodColor,
    markIn: analiSodMarkIn,
    markOut: analiSodMarkOut,
  } = calculateResultProperties(analiSodResult, analiSodLow, analiSodHigh);

  // Potasio, Suero/Pl
  const [analiPotasResult, setAnaliPotasResult] = useState(undefined);
  const [analiPotasLow, setAnaliPotasLow] = useState(undefined);
  const [analiPotasHigh, setAnaliPotasHigh] = useState(undefined);
  const {
    color: analiPotasColor,
    markIn: analiPotasMarkIn,
    markOut: analiPotasMarkOut,
  } = calculateResultProperties(
    analiPotasResult,
    analiPotasLow,
    analiPotasHigh
  );

  // Vitamina B12, Suero/Pl
  const [analiVitbResult, setAnaliVitbResult] = useState(undefined);
  const [analiVitbLow, setAnaliVitbLow] = useState(undefined);
  const [analiVitbHigh, setAnaliVitbHigh] = useState(undefined);
  const {
    color: analiVitbColor,
    markIn: analiVitbMarkIn,
    markOut: analiVitbMarkOut,
  } = calculateResultProperties(analiVitbResult, analiVitbLow, analiVitbHigh);

  // 25-OH Vitamina D
  const [analiVitohResult, setAnaliVitohResult] = useState(undefined);
  const [analiVitohLow, setAnaliVitohLow] = useState(undefined);
  const [analiVitohHigh, setAnaliVitohHigh] = useState(undefined);
  const {
    color: analiVitohColor,
    markIn: analiVitohMarkIn,
    markOut: analiVitohMarkOut,
  } = calculateResultProperties(
    analiVitohResult,
    analiVitohLow,
    analiVitohHigh
  );

  // Ácido Fólico Folato, Suero/Pl
  const [analiAcidfolResult, setAnaliAcidfolResult] = useState(undefined);
  const [analiAcidfolLow, setAnaliAcidfolLow] = useState(undefined);
  const [analiAcidfolHigh, setAnaliAcidfolHigh] = useState(undefined);
  const {
    color: analiAcidfolColor,
    markIn: analiAcidfolMarkIn,
    markOut: analiAcidfolMarkOut,
  } = calculateResultProperties(
    analiAcidfolResult,
    analiAcidfolLow,
    analiAcidfolHigh
  );

  // Magnesio, Suero/Pl
  const [analiMagnResult, setAnaliMagnResult] = useState(undefined);
  const [analiMagnLow, setAnaliMagnLow] = useState(undefined);
  const [analiMagnHigh, setAnaliMagnHigh] = useState(undefined);
  const {
    color: analiMagnColor,
    markIn: analiMagnMarkIn,
    markOut: analiMagnMarkOut,
  } = calculateResultProperties(analiMagnResult, analiMagnLow, analiMagnHigh);

  // Ferritina, Suero/Pl
  const [analiFerriResult, setAnaliFerriResult] = useState(undefined);
  const [analiFerriLow, setAnaliFerriLow] = useState(undefined);
  const [analiFerriHigh, setAnaliFerriHigh] = useState(undefined);
  const {
    color: analiFerriColor,
    markIn: analiFerriMarkIn,
    markOut: analiFerriMarkOut,
  } = calculateResultProperties(
    analiFerriResult,
    analiFerriLow,
    analiFerriHigh
  );

  // Proteína C Reactiva (PCR), Suero/Pl
  const [analiProtcResult, setAnaliProtcResult] = useState(undefined);
  const [analiProtcLow, setAnaliProtcLow] = useState(undefined);
  const [analiProtcHigh, setAnaliProtcHigh] = useState(undefined);
  const {
    color: analiProtcColor,
    markIn: analiProtcMarkIn,
    markOut: analiProtcMarkOut,
  } = calculateResultProperties(
    analiProtcResult,
    analiProtcLow,
    analiProtcHigh
  );

  // Cortisol
  const [analiCortiResult, setAnaliCortiResult] = useState(undefined);
  const [analiCortiLow, setAnaliCortiLow] = useState(undefined);
  const [analiCortiHigh, setAnaliCortiHigh] = useState(undefined);
  const {
    color: analiCortiColor,
    markIn: analiCortiMarkIn,
    markOut: analiCortiMarkOut,
  } = calculateResultProperties(
    analiCortiResult,
    analiCortiLow,
    analiCortiHigh
  );

  // DHEA
  const [analiDheaResult, setAnaliDheaResult] = useState(undefined);
  const [analiDheaLow, setAnaliDheaLow] = useState(undefined);
  const [analiDheaHigh, setAnaliDheaHigh] = useState(undefined);
  const {
    color: analiDheaColor,
    markIn: analiDheaMarkIn,
    markOut: analiDheaMarkOut,
  } = calculateResultProperties(analiDheaResult, analiDheaLow, analiDheaHigh);

  // DHEA-S
  const [analiDheaSResult, setAnaliDheaSResult] = useState(undefined);
  const [analiDheaSLow, setAnaliDheaSLow] = useState(undefined);
  const [analiDheaSHigh, setAnaliDheaSHigh] = useState(undefined);
  const {
    color: analiDheaSColor,
    markIn: analiDheaSMarkIn,
    markOut: analiDheaSMarkOut,
  } = calculateResultProperties(
    analiDheaSResult,
    analiDheaSLow,
    analiDheaSHigh
  );

  // Estado para verificar si se soltó un archivo JSON
  const [jsonDropped, setJsonDropped] = useState(false);

  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  useEffect(() => {
    if (
      analiCortiResult != null ||
      analiDheaResult != null ||
      analiDheaSResult != null
    ) {
      setAnaliticaIsSecond(true);
    } else {
      setAnaliticaIsSecond(false);
    }
  }, [analiCortiResult, analiDheaResult, analiDheaSResult]);

  const convertToString = (value) =>
    value !== undefined ? value.toString() : "";


  const submitAnaliticas = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      analiFecha,
      analiFechaAnali,
      analiName,
      analiSurname,
      analiDni,
      analiNhc,
      analiBed,
      analiSex,
      analiOrigen,
      analiDoctor,
      analiObs,
      analiHematiesResult,
      analiHematiesLow,
      analiHematiesHigh,
      analiHemoglobResult,
      analiHemoglobLow,
      analiHemoglobHigh,
      analiHematcrResult,
      analiHematcrLow,
      analiHematcrHigh,
      analiVcmResult,
      analiVcmLow,
      analiVcmHigh,
      analiHcmResult,
      analiHcmLow,
      analiHcmHigh,
      analiChcmResult,
      analiChcmLow,
      analiChcmHigh,
      analiIdhResult,
      analiIdhLow,
      analiIdhHigh,
      analiLeucoResult,
      analiLeucoLow,
      analiLeucoHigh,
      analiNeutrResult,
      analiNeutrLow,
      analiNeutrHigh,
      analiLinfoResult,
      analiLinfoLow,
      analiLinfoHigh,
      analiMonocResult,
      analiMonocLow,
      analiMonocHigh,
      analiEosinResult,
      analiEosinLow,
      analiEosinHigh,
      analiBasofResult,
      analiBasofLow,
      analiBasofHigh,
      analiPlaqResult,
      analiPlaqLow,
      analiPlaqHigh,
      analiPctResult,
      analiPctLow,
      analiPctHigh,
      analiVpmResult,
      analiVpmLow,
      analiVpmHigh,
      analiIdpResult,
      analiIdpLow,
      analiIdpHigh,
      analiTieProtResult,
      analiTieProtLow,
      analiTieProtHigh,
      analiActProtResult,
      analiActProtLow,
      analiActProtHigh,
      analiInrResult,
      analiInrLow,
      analiInrHigh,
      analiGlucResult,
      analiGlucLow,
      analiGlucHigh,
      analiUreaResult,
      analiUreaLow,
      analiUreaHigh,
      analiCreatResult,
      analiCreatLow,
      analiCreatHigh,
      analiGlomResult,
      analiGlomLow,
      analiGlomHigh,
      analiAsparResult,
      analiAsparLow,
      analiAsparHigh,
      analiAlanResult,
      analiAlanLow,
      analiAlanHigh,
      analiGammResult,
      analiGammLow,
      analiGammHigh,
      analiFosfResult,
      analiFosfLow,
      analiFosfHigh,
      analiBiliResult,
      analiBiliLow,
      analiBiliHigh,
      analiColestResult,
      analiColestLow,
      analiColestHigh,
      analiColestHdlResult,
      analiColestHdlLow,
      analiColestHdlHigh,
      analiColestLdlResult,
      analiColestLdlLow,
      analiColestLdlHigh,
      analiTriglResult,
      analiTriglLow,
      analiTriglHigh,
      analiCalcResult,
      analiCalcLow,
      analiCalcHigh,
      analiHierrResult,
      analiHierrLow,
      analiHierrHigh,
      analiSodResult,
      analiSodLow,
      analiSodHigh,
      analiPotasResult,
      analiPotasLow,
      analiPotasHigh,
      analiVitbResult,
      analiVitbLow,
      analiVitbHigh,
      analiVitohResult,
      analiVitohLow,
      analiVitohHigh,
      analiAcidfolResult,
      analiAcidfolLow,
      analiAcidfolHigh,
      analiMagnResult,
      analiMagnLow,
      analiMagnHigh,
      analiFerriResult,
      analiFerriLow,
      analiFerriHigh,
      analiProtcResult,
      analiProtcLow,
      analiProtcHigh,
      analiCortiResult,
      analiCortiLow,
      analiCortiHigh,
      analiDheaResult,
      analiDheaLow,
      analiDheaHigh,
      analiDheaSResult,
      analiDheaSLow,
      analiDheaSHigh,
      isNotJson,
      analiticaIsSecond,
      analiticaJson,
      tratamientoId,
      pacienteId
    );
    try {
      let analiFileUrl = '';
      console.log(analiFile);
      if (analiFile instanceof File) { // Verifico si analiFile es un objeto File
        const uploadResult = await FileUploader(analiFile);
        console.log(uploadResult);
        analiFileUrl = uploadResult.source_url;
      }
      const val = await AnaliticasCreate(
        analiFecha,
        analiFechaAnali,
        analiName,
        analiSurname,
        analiDni,
        analiNhc,
        analiBed,
        analiSex,
        analiOrigen,
        analiDoctor,
        analiObs,
        convertToString(analiHematiesResult),
        convertToString(analiHematiesLow),
        convertToString(analiHematiesHigh),
        convertToString(analiHemoglobResult),
        convertToString(analiHemoglobLow),
        convertToString(analiHemoglobHigh),
        convertToString(analiHematcrResult),
        convertToString(analiHematcrLow),
        convertToString(analiHematcrHigh),
        convertToString(analiVcmResult),
        convertToString(analiVcmLow),
        convertToString(analiVcmHigh),
        convertToString(analiHcmResult),
        convertToString(analiHcmLow),
        convertToString(analiHcmHigh),
        convertToString(analiChcmResult),
        convertToString(analiChcmLow),
        convertToString(analiChcmHigh),
        convertToString(analiIdhResult),
        convertToString(analiIdhLow),
        convertToString(analiIdhHigh),
        convertToString(analiLeucoResult),
        convertToString(analiLeucoLow),
        convertToString(analiLeucoHigh),
        convertToString(analiNeutrResult),
        convertToString(analiNeutrLow),
        convertToString(analiNeutrHigh),
        convertToString(analiLinfoResult),
        convertToString(analiLinfoLow),
        convertToString(analiLinfoHigh),
        convertToString(analiMonocResult),
        convertToString(analiMonocLow),
        convertToString(analiMonocHigh),
        convertToString(analiEosinResult),
        convertToString(analiEosinLow),
        convertToString(analiEosinHigh),
        convertToString(analiBasofResult),
        convertToString(analiBasofLow),
        convertToString(analiBasofHigh),
        convertToString(analiPlaqResult),
        convertToString(analiPlaqLow),
        convertToString(analiPlaqHigh),
        convertToString(analiPctResult),
        convertToString(analiPctLow),
        convertToString(analiPctHigh),
        convertToString(analiVpmResult),
        convertToString(analiVpmLow),
        convertToString(analiVpmHigh),
        convertToString(analiIdpResult),
        convertToString(analiIdpLow),
        convertToString(analiIdpHigh),
        convertToString(analiTieProtResult),
        convertToString(analiTieProtLow),
        convertToString(analiTieProtHigh),
        convertToString(analiActProtResult),
        convertToString(analiActProtLow),
        convertToString(analiActProtHigh),
        convertToString(analiInrResult),
        convertToString(analiInrLow),
        convertToString(analiInrHigh),
        convertToString(analiGlucResult),
        convertToString(analiGlucLow),
        convertToString(analiGlucHigh),
        convertToString(analiUreaResult),
        convertToString(analiUreaLow),
        convertToString(analiUreaHigh),
        convertToString(analiCreatResult),
        convertToString(analiCreatLow),
        convertToString(analiCreatHigh),
        convertToString(analiGlomResult),
        convertToString(analiGlomLow),
        convertToString(analiGlomHigh),
        convertToString(analiAsparResult),
        convertToString(analiAsparLow),
        convertToString(analiAsparHigh),
        convertToString(analiAlanResult),
        convertToString(analiAlanLow),
        convertToString(analiAlanHigh),
        convertToString(analiGammResult),
        convertToString(analiGammLow),
        convertToString(analiGammHigh),
        convertToString(analiFosfResult),
        convertToString(analiFosfLow),
        convertToString(analiFosfHigh),
        convertToString(analiBiliResult),
        convertToString(analiBiliLow),
        convertToString(analiBiliHigh),
        convertToString(analiColestResult),
        convertToString(analiColestLow),
        convertToString(analiColestHigh),
        convertToString(analiColestHdlResult),
        convertToString(analiColestHdlLow),
        convertToString(analiColestHdlHigh),
        convertToString(analiColestLdlResult),
        convertToString(analiColestLdlLow),
        convertToString(analiColestLdlHigh),
        convertToString(analiTriglResult),
        convertToString(analiTriglLow),
        convertToString(analiTriglHigh),
        convertToString(analiCalcResult),
        convertToString(analiCalcLow),
        convertToString(analiCalcHigh),
        convertToString(analiHierrResult),
        convertToString(analiHierrLow),
        convertToString(analiHierrHigh),
        convertToString(analiSodResult),
        convertToString(analiSodLow),
        convertToString(analiSodHigh),
        convertToString(analiPotasResult),
        convertToString(analiPotasLow),
        convertToString(analiPotasHigh),
        convertToString(analiVitbResult),
        convertToString(analiVitbLow),
        convertToString(analiVitbHigh),
        convertToString(analiVitohResult),
        convertToString(analiVitohLow),
        convertToString(analiVitohHigh),
        convertToString(analiAcidfolResult),
        convertToString(analiAcidfolLow),
        convertToString(analiAcidfolHigh),
        convertToString(analiMagnResult),
        convertToString(analiMagnLow),
        convertToString(analiMagnHigh),
        convertToString(analiFerriResult),
        convertToString(analiFerriLow),
        convertToString(analiFerriHigh),
        convertToString(analiProtcResult),
        convertToString(analiProtcLow),
        convertToString(analiProtcHigh),
        convertToString(analiCortiResult),
        convertToString(analiCortiLow),
        convertToString(analiCortiHigh),
        convertToString(analiDheaResult),
        convertToString(analiDheaLow),
        convertToString(analiDheaHigh),
        convertToString(analiDheaSResult),
        convertToString(analiDheaSLow),
        convertToString(analiDheaSHigh),
        isNotJson,
        analiticaIsSecond,
        analiFileUrl,
        analiticaJson,
        tratamientoId,
        pacienteId
      );
      window.location.replace(`../analiticas/${val.id}`);
      //console.log(val);
    } catch (error) {
      console.log(error);
    }
    setIsCreatingButton(false);
  };

  const processFile = (file) => {
  if (file) {
    const reader = new FileReader();

    setAnaliFile(file);

    reader.onload = (e) => {
      try {
        const jsonData = tryParseJSON(e.target.result);
        const jsonDataString = JSON.stringify(jsonData);
        setAnaliticaJson(jsonDataString);

        if (jsonData) {
          // Asignar los valores directamente sin verificaciones
          if (jsonData?.date) {
            setAnaliFechaAnali(jsonData.date);
          }
          if (jsonData?.pat_nombre) {
            const pat_nombre = jsonData.pat_nombre.replace(
              /[^\x00-\x7F]/g,
              "Ñ"
            );
            setAnaliName(pat_nombre);
          }
          if (jsonData?.pat_apell1 && jsonData.pat_apell2) {
            const pat_apell1 = jsonData.pat_apell1.replace(
              /[^\x00-\x7F]/g,
              "Ñ"
            );
            const pat_apell2 = jsonData.pat_apell2.replace(
              /[^\x00-\x7F]/g,
              "Ñ"
            );
            const surnameClean = `${pat_apell1} ${pat_apell2}`;
            setAnaliSurname(surnameClean);
          }
          if (jsonData?.bed) {
            setAnaliBed(jsonData.bed);
          }
          if (jsonData?.pat_histo) {
            setAnaliNhc(jsonData.pat_histo);
          }
          if (jsonData?.pat_nif) {
            setAnaliDni(jsonData.pat_nif);
          }
          if (jsonData?.pat_sex_name) {
            setAnaliSex(jsonData.pat_sex_name);
          }
          if (jsonData?.collpoint_name) {
            setAnaliOrigen(jsonData.collpoint_name);
          }
          if (jsonData?.medico_nuevo) {
            setAnaliDoctor(jsonData.medico_nuevo);
          }
          if (jsonData?.pat_obs) {
            setAnaliObs(jsonData.pat_obs);
          }

          const results = {};
          // Comprobacion de resultado de Hematies
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_12?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_12.num !== null
          ) {
            setAnaliHematiesResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_12.num
            );
          } else {
            const errorMessage = "Faltan datos de Hematies.";
            console.error(
              "El dato setAnaliHematiesResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Hematies
          const hematiesLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_12?.limits2;

          if (
            hematiesLimits?.L !== undefined &&
            hematiesLimits?.H !== undefined &&
            hematiesLimits?.L !== null &&
            hematiesLimits?.H !== null
          ) {
            setAnaliHematiesLow(parseFloat(hematiesLimits.L).toFixed(2));
            setAnaliHematiesHigh(parseFloat(hematiesLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de hematíes no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Comprobacion de resultado de Hemoglobina
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_13?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_13.num !== null
          ) {
            setAnaliHemoglobResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_13.num
            );
          } else {
            const errorMessage = "Faltan datos de Hemoglobina.";
            console.error(
              "El dato setAnaliHemoglobResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Hemoglobina
          const hemoglobLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_13?.limits2;

          if (
            hemoglobLimits?.L !== undefined &&
            hemoglobLimits?.H !== undefined &&
            hemoglobLimits?.L !== null &&
            hemoglobLimits?.H !== null
          ) {
            setAnaliHemoglobLow(parseFloat(hemoglobLimits.L).toFixed(2));
            setAnaliHemoglobHigh(parseFloat(hemoglobLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Hemoglobina no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Comprobacion de resultado de Hematocrito
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_14?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_14.num !== null
          ) {
            setAnaliHematcrResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_14.num
            );
          } else {
            const errorMessage = "Faltan datos de Hematocrito.";
            console.error(
              "El dato setAnaliHematcrResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Hematocrito
          const hematcrLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_14?.limits2;

          if (
            hematcrLimits?.L !== undefined &&
            hematcrLimits?.H !== undefined &&
            hematcrLimits?.L !== null &&
            hematcrLimits?.H !== null
          ) {
            setAnaliHematcrLow(parseFloat(hematcrLimits.L).toFixed(2));
            setAnaliHematcrHigh(parseFloat(hematcrLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Hematocrito no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Comprobacion de resultado de VCM
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_15?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_15.num !== null
          ) {
            setAnaliVcmResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_15.num
            );
          } else {
            const errorMessage = "Faltan datos de VCM.";
            console.error("El dato setAnaliVcmResult está ausente en el JSON.");
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de VCM
          const vcmLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_15?.limits2;

          if (
            vcmLimits?.L !== undefined &&
            vcmLimits?.H !== undefined &&
            vcmLimits?.L !== null &&
            vcmLimits?.H !== null
          ) {
            setAnaliVcmLow(parseFloat(vcmLimits.L).toFixed(2));
            setAnaliVcmHigh(parseFloat(vcmLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de VCM no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Comprobacion de resultado de HCM
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_16?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_16.num !== null
          ) {
            setAnaliHcmResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_16.num
            );
          } else {
            const errorMessage = "Faltan datos de HCM.";
            console.error("El dato setAnaliHcmResult está ausente en el JSON.");
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de HCM
          const hcmLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_16?.limits2;

          if (
            hcmLimits?.L !== undefined &&
            hcmLimits?.H !== undefined &&
            hcmLimits?.L !== null &&
            hcmLimits?.H !== null
          ) {
            setAnaliHcmLow(parseFloat(hcmLimits.L).toFixed(2));
            setAnaliHcmHigh(parseFloat(hcmLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de HCM no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de CHCM
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_17?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_17.num !== null
          ) {
            setAnaliChcmResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_17.num
            );
          } else {
            const errorMessage = "Faltan datos de CHCM.";
            console.error(
              "El dato setAnaliChcmResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de CHCM
          const chcmLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_17?.limits2;

          if (
            chcmLimits?.L !== undefined &&
            chcmLimits?.H !== undefined &&
            chcmLimits?.L !== null &&
            chcmLimits?.H !== null
          ) {
            setAnaliChcmLow(parseFloat(chcmLimits.L).toFixed(2));
            setAnaliChcmHigh(parseFloat(chcmLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de CHCM no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de IDH
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_20?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_20.num !== null
          ) {
            setAnaliIdhResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_20.num
            );
          } else {
            const errorMessage = "Faltan datos de IDH.";
            console.error("El dato setAnaliIdhResult está ausente en el JSON.");
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de IDH
          const idhLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_20?.limits2;

          if (
            idhLimits?.L !== undefined &&
            idhLimits?.H !== undefined &&
            idhLimits?.L !== null &&
            idhLimits?.H !== null
          ) {
            setAnaliIdhLow(parseFloat(idhLimits.L).toFixed(2));
            setAnaliIdhHigh(parseFloat(idhLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de IDH no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de Leucocitos
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_18?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_18.num !== null
          ) {
            setAnaliLeucoResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_18.num
            );
          } else {
            const errorMessage = "Faltan datos de Leucocitos.";
            console.error(
              "El dato setAnaliLeucoResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Leucocitos
          const leucoLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_18?.limits2;

          if (
            leucoLimits?.L !== undefined &&
            leucoLimits?.H !== undefined &&
            leucoLimits?.L !== null &&
            leucoLimits?.H !== null
          ) {
            setAnaliLeucoLow(parseFloat(leucoLimits.L).toFixed(2));
            setAnaliLeucoHigh(parseFloat(leucoLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Leucocitos no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de Neutrófilos segmentados
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_38?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_38.num !== null
          ) {
            setAnaliNeutrResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_38.num
            );
          } else {
            const errorMessage = "Faltan datos de Neutrófilos segmentados.";
            console.error(
              "El dato setAnaliNeutrResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Neutrófilos segmentados
          const neutrLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_38?.limits2;

          if (
            neutrLimits?.L !== undefined &&
            neutrLimits?.H !== undefined &&
            neutrLimits?.L !== null &&
            neutrLimits?.H !== null
          ) {
            setAnaliNeutrLow(parseFloat(neutrLimits.L).toFixed(2));
            setAnaliNeutrHigh(parseFloat(neutrLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Neutrófilos segmentados no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Linfocitos
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_40?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_40.num !== null
          ) {
            setAnaliLinfoResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_40.num
            );
          } else {
            const errorMessage = "Faltan datos de Linfocitos.";
            console.error(
              "El dato setAnaliLinfoResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Linfocitos
          const linfoLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_40?.limits2;

          if (
            linfoLimits?.L !== undefined &&
            linfoLimits?.H !== undefined &&
            linfoLimits?.L !== null &&
            linfoLimits?.H !== null
          ) {
            setAnaliLinfoLow(parseFloat(linfoLimits.L).toFixed(2));
            setAnaliLinfoHigh(parseFloat(linfoLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Linfocitos no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Monocitos
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_41?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_41.num !== null
          ) {
            setAnaliMonocResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_41.num
            );
          } else {
            const errorMessage = "Faltan datos de Monocitos.";
            console.error(
              "El dato setAnaliMonocResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Monocitos
          const monocLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_41?.limits2;

          if (
            monocLimits?.L !== undefined &&
            monocLimits?.H !== undefined &&
            monocLimits?.L !== null &&
            monocLimits?.H !== null
          ) {
            setAnaliMonocLow(parseFloat(monocLimits.L).toFixed(2));
            setAnaliMonocHigh(parseFloat(monocLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Monocitos no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Eosinófilos
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_31?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_31.num !== null
          ) {
            setAnaliEosinResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_31.num
            );
          } else {
            const errorMessage = "Faltan datos de Eosinófilos.";
            console.error(
              "El dato setAnaliEosinResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Eosinófilos
          const eosinLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_31?.limits2;

          if (
            eosinLimits?.L !== undefined &&
            eosinLimits?.H !== undefined &&
            eosinLimits?.L !== null &&
            eosinLimits?.H !== null
          ) {
            setAnaliEosinLow(parseFloat(eosinLimits.L).toFixed(2));
            setAnaliEosinHigh(parseFloat(eosinLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Eosinófilos no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Basófilos
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_33?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_33.num !== null
          ) {
            setAnaliBasofResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_33.num
            );
          } else {
            const errorMessage = "Faltan datos de Basófilos.";
            console.error(
              "El dato setAnaliBasofResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Basófilos
          const basofLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_33?.limits2;

          if (
            basofLimits?.L !== undefined &&
            basofLimits?.H !== undefined &&
            basofLimits?.L !== null &&
            basofLimits?.H !== null
          ) {
            setAnaliBasofLow(parseFloat(basofLimits.L).toFixed(2));
            setAnaliBasofHigh(parseFloat(basofLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Basófilos no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Plaquetas
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_19?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_19.num !== null
          ) {
            setAnaliPlaqResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_19.num
            );
          } else {
            const errorMessage = "Faltan datos de Plaquetas.";
            console.error(
              "El dato setAnaliPlaqResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Plaquetas
          const plaqLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_19?.limits2;

          if (
            plaqLimits?.L !== undefined &&
            plaqLimits?.H !== undefined &&
            plaqLimits?.L !== null &&
            plaqLimits?.H !== null
          ) {
            setAnaliPlaqLow(parseFloat(plaqLimits.L).toFixed(2));
            setAnaliPlaqHigh(parseFloat(plaqLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Plaquetas no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  PCT
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_22?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_22.num !== null
          ) {
            setAnaliPctResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_22.num
            );
          } else {
            const errorMessage = "Faltan datos de PCT.";
            console.error("El dato setAnaliPctResult está ausente en el JSON.");
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de PCT
          const pctLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_22?.limits2;

          if (
            pctLimits?.L !== undefined &&
            pctLimits?.H !== undefined &&
            pctLimits?.L !== null &&
            pctLimits?.H !== null
          ) {
            setAnaliPctLow(parseFloat(pctLimits.L).toFixed(2));
            setAnaliPctHigh(parseFloat(pctLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de PCT no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  VPM
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_30?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_30.num !== null
          ) {
            setAnaliVpmResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_30.num
            );
          } else {
            const errorMessage = "Faltan datos de VPM.";
            console.error("El dato setAnaliVpmResult está ausente en el JSON.");
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de VPM
          const vpmLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_30?.limits2;

          if (
            vpmLimits?.L !== undefined &&
            vpmLimits?.H !== undefined &&
            vpmLimits?.L !== null &&
            vpmLimits?.H !== null
          ) {
            setAnaliVpmLow(parseFloat(vpmLimits.L).toFixed(2));
            setAnaliVpmHigh(parseFloat(vpmLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de VPM no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  IDP
          if (
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_23?.num !==
              undefined &&
            jsonData.results.GEN.HEM["TK:HEMO"].data.A_23.num !== null
          ) {
            setAnaliIdpResult(
              jsonData.results.GEN.HEM["TK:HEMO"].data.A_23.num
            );
          } else {
            const errorMessage = "Faltan datos de IDP.";
            console.error("El dato setAnaliIdpResult está ausente en el JSON.");
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de IDP
          const idpLimits =
            jsonData.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_23?.limits2;

          if (
            idpLimits?.L !== undefined &&
            idpLimits?.H !== undefined &&
            idpLimits?.L !== null &&
            idpLimits?.H !== null
          ) {
            setAnaliIdpLow(parseFloat(idpLimits.L).toFixed(2));
            setAnaliIdpHigh(parseFloat(idpLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de IDP no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Tiempo de Protrombina (seg).
          if (
            jsonData.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_176?.num !==
              undefined &&
            jsonData.results.GEN.COAG["TK:A_174"].data.A_176.num !== null
          ) {
            setAnaliTieProtResult(
              jsonData.results.GEN.COAG["TK:A_174"].data.A_176.num
            );
          } else {
            const errorMessage = "Faltan datos de Tiempo de Protrombina (seg).";
            console.error(
              "El dato setAnaliTieProtResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Tiempo de Protrombina (seg)
          const tieProtLimits =
            jsonData.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_176?.limits2;

          if (
            tieProtLimits?.L !== undefined &&
            tieProtLimits?.H !== undefined &&
            tieProtLimits?.L !== null &&
            tieProtLimits?.H !== null
          ) {
            setAnaliTieProtLow(parseFloat(tieProtLimits.L).toFixed(2));
            setAnaliTieProtHigh(parseFloat(tieProtLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Tiempo de Protrombina (seg) no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Actividad de Protrombina (%)
          if (
            jsonData.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_177?.num !==
              undefined &&
            jsonData.results.GEN.COAG["TK:A_174"].data.A_177.num !== null
          ) {
            setAnaliActProtResult(
              jsonData.results.GEN.COAG["TK:A_174"].data.A_177.num
            );
          } else {
            const errorMessage =
              "Faltan datos de Actividad de Protrombina (%).";
            console.error(
              "El dato setAnaliActProtResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Actividad de Protrombina (%)
          const actProtLimits =
            jsonData.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_177?.limits2;

          if (
            actProtLimits?.L !== undefined &&
            actProtLimits?.H !== undefined &&
            actProtLimits?.L !== null &&
            actProtLimits?.H !== null
          ) {
            setAnaliActProtLow(parseFloat(actProtLimits.L).toFixed(2));
            setAnaliActProtHigh(parseFloat(actProtLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Actividad de Protrombina (%) no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de INR
          if (
            jsonData.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_179?.num !==
              undefined &&
            jsonData.results.GEN.COAG["TK:A_174"].data.A_179.num !== null
          ) {
            setAnaliInrResult(
              jsonData.results.GEN.COAG["TK:A_174"].data.A_179.num
            );
          } else {
            const errorMessage = "Faltan datos de INR.";
            console.error("El dato setAnaliInrResult está ausente en el JSON.");
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de INR
          const inrLimits =
            jsonData.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_179?.limits2;

          if (
            inrLimits?.L !== undefined &&
            inrLimits?.H !== undefined &&
            inrLimits?.L !== null &&
            inrLimits?.H !== null
          ) {
            setAnaliInrLow(parseFloat(inrLimits.L).toFixed(2));
            setAnaliInrHigh(parseFloat(inrLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de INR no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de Glucosa, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_384"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_384"].num !== null
          ) {
            setAnaliGlucResult(jsonData.results.GEN.BIOQ["TK:A_384"].num);
          } else {
            const errorMessage = "Faltan datos de Glucosa, Suero/Pl.";
            console.error(
              "El dato setAnaliGlucResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Glucosa, Suero/Pl.
          const glucLimits = jsonData.results?.GEN?.BIOQ?.["TK:A_384"]?.limits2;

          if (
            glucLimits?.L !== undefined &&
            glucLimits?.H !== undefined &&
            glucLimits?.L !== null &&
            glucLimits?.H !== null
          ) {
            setAnaliGlucLow(parseFloat(glucLimits.L).toFixed(2));
            setAnaliGlucHigh(parseFloat(glucLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Glucosa, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de Urea
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_436"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_436"].num !== null
          ) {
            setAnaliUreaResult(jsonData.results.GEN.BIOQ["TK:A_436"].num);
          } else {
            const errorMessage = "Faltan datos de Urea.";
            console.error(
              "El dato setAnaliUreaResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Urea
          const ureaLimits = jsonData.results?.GEN?.BIOQ?.["TK:A_436"]?.limits2;

          if (
            ureaLimits?.L !== undefined &&
            ureaLimits?.H !== undefined &&
            ureaLimits?.L !== null &&
            ureaLimits?.H !== null
          ) {
            setAnaliUreaLow(parseFloat(ureaLimits.L).toFixed(2));
            setAnaliUreaHigh(parseFloat(ureaLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Urea no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Creatinina, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_437"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_437"].num !== null
          ) {
            setAnaliCreatResult(jsonData.results.GEN.BIOQ["TK:A_437"].num);
          } else {
            const errorMessage = "Faltan datos de Creatinina, Suero/Pl.";
            console.error(
              "El dato setAnaliCreatResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Creatinina, Suero/Pl.
          const creatLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_437"]?.limits2;

          if (
            creatLimits?.L !== undefined &&
            creatLimits?.H !== undefined &&
            creatLimits?.L !== null &&
            creatLimits?.H !== null
          ) {
            setAnaliCreatLow(parseFloat(creatLimits.L).toFixed(2));
            setAnaliCreatHigh(parseFloat(creatLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Creatinina, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Filtrado Glomerular CKD-EPI
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_118276"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_118276"].num !== null
          ) {
            setAnaliGlomResult(jsonData.results.GEN.BIOQ["TK:A_118276"].num);
          } else {
            const errorMessage = "Faltan datos de Filtrado Glomerular CKD-EPI.";
            console.error(
              "El dato setAnaliGlomResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Filtrado Glomerular CKD-EPI
          const GlomLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_118276"]?.limits2;

          if (
            GlomLimits?.L !== undefined &&
            GlomLimits?.H !== undefined &&
            GlomLimits?.L !== null &&
            GlomLimits?.H !== null
          ) {
            setAnaliGlomLow(parseFloat(GlomLimits.L).toFixed(2));
            setAnaliGlomHigh(parseFloat(GlomLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Filtrado Glomerular CKD-EPI no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de Aspartato Amino Transferasa (AST/GOT), Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_498"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_498"].num !== null
          ) {
            setAnaliAsparResult(jsonData.results.GEN.BIOQ["TK:A_498"].num);
          } else {
            const errorMessage =
              "Faltan datos de Aspartato Amino Transferasa (AST/GOT), Suero/Pl.";
            console.error(
              "El dato setAnaliAsparResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Aspartato Amino Transferasa (AST/GOT), Suero/Pl.
          const asparLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_498"]?.limits2;

          if (
            asparLimits?.L !== undefined &&
            asparLimits?.H !== undefined &&
            asparLimits?.L !== null &&
            asparLimits?.H !== null
          ) {
            setAnaliAsparLow(parseFloat(asparLimits.L).toFixed(2));
            setAnaliAsparHigh(parseFloat(asparLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Aspartato Amino Transferasa (AST/GOT), Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Alanina Amino Transferasa (ALT/GPT), Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_499"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_499"].num !== null
          ) {
            setAnaliAlanResult(jsonData.results.GEN.BIOQ["TK:A_499"].num);
          } else {
            const errorMessage =
              "Faltan datos de Alanina Amino Transferasa (ALT/GPT), Suero/Pl.";
            console.error(
              "El dato setAnaliAlanResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Alanina Amino Transferasa (ALT/GPT), Suero/Pl.
          const alanLimits = jsonData.results?.GEN?.BIOQ?.["TK:A_499"]?.limits2;

          if (
            alanLimits?.L !== undefined &&
            alanLimits?.H !== undefined &&
            alanLimits?.L !== null &&
            alanLimits?.H !== null
          ) {
            setAnaliAlanLow(parseFloat(alanLimits.L).toFixed(2));
            setAnaliAlanHigh(parseFloat(alanLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Alanina Amino Transferasa (ALT/GPT), Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Gamma Glutamil Transferasa (GGT), Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_500"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_500"].num !== null
          ) {
            setAnaliGammResult(jsonData.results.GEN.BIOQ["TK:A_500"].num);
          } else {
            const errorMessage =
              "Faltan datos de Gamma Glutamil Transferasa (GGT), Suero/Pl.";
            console.error(
              "El dato setAnaliGammResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Gamma Glutamil Transferasa (GGT), Suero/Pl.
          const gammLimits = jsonData.results?.GEN?.BIOQ?.["TK:A_500"]?.limits2;

          if (
            gammLimits?.L !== undefined &&
            gammLimits?.H !== undefined &&
            gammLimits?.L !== null &&
            gammLimits?.H !== null
          ) {
            setAnaliGammLow(parseFloat(gammLimits.L).toFixed(2));
            setAnaliGammHigh(parseFloat(gammLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Gamma Glutamil Transferasa (GGT), Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de Fosfatasa Alcalina (FA), Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_501"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_501"].num !== null
          ) {
            setAnaliFosfResult(jsonData.results.GEN.BIOQ["TK:A_501"].num);
          } else {
            const errorMessage =
              "Faltan datos de Fosfatasa Alcalina (FA), Suero/Pl.";
            console.error(
              "El dato setAnaliFosfResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Fosfatasa Alcalina (FA), Suero/Pl.
          const fosfLimits = jsonData.results?.GEN?.BIOQ?.["TK:A_501"]?.limits2;

          if (
            fosfLimits?.L !== undefined &&
            fosfLimits?.H !== undefined &&
            fosfLimits?.L !== null &&
            fosfLimits?.H !== null
          ) {
            setAnaliFosfLow(parseFloat(fosfLimits.L).toFixed(2));
            setAnaliFosfHigh(parseFloat(fosfLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Fosfatasa Alcalina (FA), Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Bilirrubina total, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_549"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_549"].num !== null
          ) {
            setAnaliBiliResult(jsonData.results.GEN.BIOQ["TK:A_549"].num);
          } else {
            const errorMessage = "Faltan datos de Bilirrubina total, Suero/Pl.";
            console.error(
              "El dato setAnaliBiliResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Bilirrubina total, Suero/Pl.
          const biliLimits = jsonData.results?.GEN?.BIOQ?.["TK:A_549"]?.limits2;

          if (
            biliLimits?.L !== undefined &&
            biliLimits?.H !== undefined &&
            biliLimits?.L !== null &&
            biliLimits?.H !== null
          ) {
            setAnaliBiliLow(parseFloat(biliLimits.L).toFixed(2));
            setAnaliBiliHigh(parseFloat(biliLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Bilirrubina total, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Colesterol, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_556"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_556"].num !== null
          ) {
            setAnaliColestResult(jsonData.results.GEN.BIOQ["TK:A_556"].num);
          } else {
            const errorMessage = "Faltan datos de Colesterol, Suero/Pl.";
            console.error(
              "El dato setAnaliColestResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Colesterol, Suero/Pl.
          const colestLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_556"]?.limits2;

          if (
            colestLimits?.L !== undefined &&
            colestLimits?.H !== undefined &&
            colestLimits?.L !== null &&
            colestLimits?.H !== null
          ) {
            setAnaliColestLow(parseFloat(colestLimits.L).toFixed(2));
            setAnaliColestHigh(parseFloat(colestLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Colesterol, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Colesterol HDL, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_557"]?.num !== undefined &&
            jsonData.results?.GEN?.BIOQ["TK:A_557"]?.num !== null
          ) {
            setAnaliColestHdlResult(
              jsonData.results?.GEN?.BIOQ["TK:A_557"]?.num
            );
          } else {
            const errorMessage = "Faltan datos de Colesterol HDL, Suero/Pl.";
            console.error(
              "El dato setAnaliColestHdlResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Colesterol HDL, Suero/Pl.
          const colestHdlLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_557"]?.limits2;

          if (
            colestHdlLimits?.L !== undefined &&
            colestHdlLimits?.H !== undefined &&
            colestHdlLimits?.L !== null &&
            colestHdlLimits?.H !== null
          ) {
            setAnaliColestHdlLow(parseFloat(colestHdlLimits.L).toFixed(2));
            setAnaliColestHdlHigh(parseFloat(colestHdlLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Colesterol HDL, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Colesterol LDL, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_574"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_574"].num !== null
          ) {
            setAnaliColestLdlResult(jsonData.results.GEN.BIOQ["TK:A_574"].num);
          } else {
            const errorMessage = "Faltan datos de Colesterol LDL, Suero/Pl.";
            console.error(
              "El dato setAnaliColestLdlResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Colesterol LDL, Suero/Pl.
          const colestLdlLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_574"]?.limits2;

          if (
            colestLdlLimits?.L !== undefined &&
            colestLdlLimits?.H !== undefined &&
            colestLdlLimits?.L !== null &&
            colestLdlLimits?.H !== null
          ) {
            setAnaliColestLdlLow(parseFloat(colestLdlLimits.L).toFixed(2));
            setAnaliColestLdlHigh(parseFloat(colestLdlLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Colesterol LDL, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Triglicéridos, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_564"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_564"].num !== null
          ) {
            setAnaliTriglResult(jsonData.results.GEN.BIOQ["TK:A_564"].num);
          } else {
            const errorMessage = "Faltan datos de Triglicéridos, Suero/Pl.";
            console.error(
              "El dato setAnaliTriglResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Triglicéridos, Suero/Pl.
          const triglLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_564"]?.limits2;

          if (
            triglLimits?.L !== undefined &&
            triglLimits?.H !== undefined &&
            triglLimits?.L !== null &&
            triglLimits?.H !== null
          ) {
            setAnaliTriglLow(parseFloat(triglLimits.L).toFixed(2));
            setAnaliTriglHigh(parseFloat(triglLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Triglicéridos, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Calcio, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_467"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_467"].num !== null
          ) {
            setAnaliCalcResult(jsonData.results.GEN.BIOQ["TK:A_467"].num);
          } else {
            const errorMessage = "Faltan datos de Calcio, Suero/Pl.";
            console.error(
              "El dato setAnaliCalcResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Calcio, Suero/Pl.
          const calcLimits = jsonData.results?.GEN?.BIOQ?.["TK:A_467"]?.limits2;

          if (
            calcLimits?.L !== undefined &&
            calcLimits?.H !== undefined &&
            calcLimits?.L !== null &&
            calcLimits?.H !== null
          ) {
            setAnaliCalcLow(parseFloat(calcLimits.L).toFixed(2));
            setAnaliCalcHigh(parseFloat(calcLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Calcio, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Hierro, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_596"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_596"].num !== null
          ) {
            setAnaliHierrResult(jsonData.results.GEN.BIOQ["TK:A_596"].num);
          } else {
            const errorMessage = "Faltan datos de Hierro, Suero/Pl.";
            console.error(
              "El dato setAnaliHierrResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Hierro, Suero/Pl.
          const hierrLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_596"]?.limits2;

          if (
            hierrLimits?.L !== undefined &&
            hierrLimits?.H !== undefined &&
            hierrLimits?.L !== null &&
            hierrLimits?.H !== null
          ) {
            setAnaliHierrLow(parseFloat(hierrLimits.L).toFixed(2));
            setAnaliHierrHigh(parseFloat(hierrLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Hierro, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Sodio, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_613"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_613"].num !== null
          ) {
            setAnaliSodResult(jsonData.results.GEN.BIOQ["TK:A_613"].num);
          } else {
            const errorMessage = "Faltan datos de Sodio, Suero/Pl.";
            console.error("El dato setAnaliSodResult está ausente en el JSON.");
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Sodio, Suero/Pl.
          const sodLimits = jsonData.results?.GEN?.BIOQ?.["TK:A_613"]?.limits2;

          if (
            sodLimits?.L !== undefined &&
            sodLimits?.H !== undefined &&
            sodLimits?.L !== null &&
            sodLimits?.H !== null
          ) {
            setAnaliSodLow(parseFloat(sodLimits.L).toFixed(2));
            setAnaliSodHigh(parseFloat(sodLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Sodio, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Potasio, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_614"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_614"].num !== null
          ) {
            setAnaliPotasResult(jsonData.results.GEN.BIOQ["TK:A_614"].num);
          } else {
            const errorMessage = "Faltan datos de Potasio, Suero/Pl.";
            console.error(
              "El dato setAnaliPotasResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Potasio, Suero/Pl.
          const potasLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_614"]?.limits2;

          if (
            potasLimits?.L !== undefined &&
            potasLimits?.H !== undefined &&
            potasLimits?.L !== null &&
            potasLimits?.H !== null
          ) {
            setAnaliPotasLow(parseFloat(potasLimits.L).toFixed(2));
            setAnaliPotasHigh(parseFloat(potasLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Potasio, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de Vitamina B12, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_894"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_894"].num !== null
          ) {
            setAnaliVitbResult(jsonData.results.GEN.BIOQ["TK:A_894"].num);
          } else {
            const errorMessage = "Faltan datos de Vitamina B12, Suero/Pl.";
            console.error(
              "El dato setAnaliVitbResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Vitamina B12, Suero/Pl.
          const vitbLimits = jsonData.results?.GEN?.BIOQ?.["TK:A_894"]?.limits2;

          if (
            vitbLimits?.L !== undefined &&
            vitbLimits?.H !== undefined &&
            vitbLimits?.L !== null &&
            vitbLimits?.H !== null
          ) {
            setAnaliVitbLow(parseFloat(vitbLimits.L).toFixed(2));
            setAnaliVitbHigh(parseFloat(vitbLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Vitamina B12, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  25-OH Vitamina D.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_902"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_902"].num !== null
          ) {
            setAnaliVitohResult(jsonData.results.GEN.BIOQ["TK:A_902"].num);
          } else {
            const errorMessage = "Faltan datos de 25-OH Vitamina D.";
            console.error(
              "El dato setAnaliVitohResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de 25-OH Vitamina D.
          const vitohLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_902"]?.limits2;

          if (
            vitohLimits?.L !== undefined &&
            vitohLimits?.H !== undefined &&
            vitohLimits?.L !== null &&
            vitohLimits?.H !== null
          ) {
            setAnaliVitohLow(parseFloat(vitohLimits.L).toFixed(2));
            setAnaliVitohHigh(parseFloat(vitohLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de 25-OH Vitamina D. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Acido Folico Folato, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_890"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_890"].num !== null
          ) {
            setAnaliAcidfolResult(jsonData.results.GEN.BIOQ["TK:A_890"].num);
          } else {
            const errorMessage =
              "Faltan datos de Acido Folico Folato, Suero/Pl.";
            console.error(
              "El dato setAnaliAcidfolResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Ácido Fólico Folato, Suero/Pl.
          const acidfolLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_890"]?.limits2;

          if (
            acidfolLimits?.L !== undefined &&
            acidfolLimits?.H !== undefined &&
            acidfolLimits?.L !== null &&
            acidfolLimits?.H !== null
          ) {
            setAnaliAcidfolLow(parseFloat(acidfolLimits.L).toFixed(2));
            setAnaliAcidfolHigh(parseFloat(acidfolLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Ácido Fólico Folato, Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Magnesio, Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_1284"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_1284"].num !== null
          ) {
            setAnaliMagnResult(jsonData.results.GEN.BIOQ["TK:A_1284"].num);
          } else {
            const errorMessage = "Faltan datos de Magnesio, Suero/Pl.";
            console.error(
              "El dato setAnaliMagnResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Magnesio, Suero/Pl.
          const magnLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_1284"]?.limits2;

          if (
            magnLimits?.L !== undefined &&
            magnLimits?.H !== undefined &&
            magnLimits?.L !== null &&
            magnLimits?.H !== null
          ) {
            setAnaliMagnLow(parseFloat(magnLimits.L).toFixed(2));
            setAnaliMagnHigh(parseFloat(magnLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de hemaMagnesio, Suero/Pl.ties no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de Ferritina
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_1042"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_1042"].num !== null
          ) {
            setAnaliFerriResult(jsonData.results.GEN.BIOQ["TK:A_1042"].num);
          } else {
            const errorMessage = "Faltan datos de Ferritina.";
            console.error(
              "El dato setAnaliFerriResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Ferritina
          const ferriLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_1042"]?.limits2;

          if (
            ferriLimits?.L !== undefined &&
            ferriLimits?.H !== undefined &&
            ferriLimits?.L !== null &&
            ferriLimits?.H !== null
          ) {
            setAnaliFerriLow(parseFloat(ferriLimits.L).toFixed(2));
            setAnaliFerriHigh(parseFloat(ferriLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Ferritina no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de  Proteína C Reactiva (PCR), Suero/Pl.
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_764"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_764"].num !== null
          ) {
            setAnaliProtcResult(jsonData.results.GEN.BIOQ["TK:A_764"].num);
          } else {
            const errorMessage =
              "Faltan datos de Proteína C Reactiva (PCR), Suero/Pl.";
            console.error(
              "El dato setAnaliProtcResult está ausente en el JSON."
            );
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Proteína C Reactiva (PCR), Suero/Pl.
          const protcLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_764"]?.limits2;

          if (
            protcLimits?.L !== undefined &&
            protcLimits?.H !== undefined &&
            protcLimits?.L !== null &&
            protcLimits?.H !== null
          ) {
            setAnaliProtcLow(parseFloat(protcLimits.L).toFixed(2));
            setAnaliProtcHigh(parseFloat(protcLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Proteína C Reactiva (PCR), Suero/Pl. no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de Cortisol
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_123"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_123"].num !== null
          ) {
            setAnaliCortiResult(jsonData.results.GEN.BIOQ["TK:A_123"].num);
          } else {
            const errorMessage = "Faltan datos de Cortisol";
            console.error(
              "El dato setAnaliCortiResult está ausente en el JSON."
            );
            setWarningSecondMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Cortisol
          const cortiLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_123"]?.limits2;

          if (
            cortiLimits?.L !== undefined &&
            cortiLimits?.H !== undefined &&
            cortiLimits?.L !== null &&
            cortiLimits?.H !== null
          ) {
            setAnaliCortiLow(parseFloat(cortiLimits.L).toFixed(2));
            setAnaliCortiHigh(parseFloat(cortiLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Cortisol no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningSecondMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de DHEA
          if (
            jsonData.results?.GEN?.CERBA?.["TK:A_1013"]?.num !== undefined &&
            jsonData.results.GEN.CERBA["TK:A_1013"].num !== null
          ) {
            setAnaliDheaResult(jsonData.results.GEN.CERBA["TK:A_1013"].num);
          } else {
            const errorMessage = "Faltan datos de Dhea";
            console.error(
              "El dato setAnaliDheaResult está ausente en el JSON."
            );
            setWarningSecondMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Dhea
          const dheaLimits =
            jsonData.results?.GEN?.CERBA?.["TK:A_1013"]?.limits2;

          if (
            dheaLimits?.L !== undefined &&
            dheaLimits?.H !== undefined &&
            dheaLimits?.L !== null &&
            dheaLimits?.H !== null
          ) {
            setAnaliDheaLow(parseFloat(dheaLimits.L).toFixed(2));
            setAnaliDheaHigh(parseFloat(dheaLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Dhea no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningSecondMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          //Comprobacion de resultado de DHEA-S
          if (
            jsonData.results?.GEN?.BIOQ?.["TK:A_1010"]?.num !== undefined &&
            jsonData.results.GEN.BIOQ["TK:A_1010"].num !== null
          ) {
            setAnaliDheaSResult(jsonData.results.GEN.BIOQ["TK:A_1010"].num);
          } else {
            const errorMessage = "Faltan datos de Dhea-S";
            console.error(
              "El dato setAnaliDheaSSResult está ausente en el JSON."
            );
            setWarningSecondMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Extraer límites de Dhea-S
          const dheaSLimits =
            jsonData.results?.GEN?.BIOQ?.["TK:A_1010"]?.limits2;

          if (
            dheaSLimits?.L !== undefined &&
            dheaSLimits?.H !== undefined &&
            dheaSLimits?.L !== null &&
            dheaSLimits?.H !== null
          ) {
            setAnaliDheaSLow(parseFloat(dheaSLimits.L).toFixed(2));
            setAnaliDheaSHigh(parseFloat(dheaSLimits.H).toFixed(2));
          } else {
            const errorMessage =
              "Valores de límites de Dhea-S no encontrados en el JSON.";
            console.error(errorMessage);
            setWarningSecondMessages((prevMessages) => [
              ...prevMessages,
              errorMessage,
            ]);
          }

          // Marcar que se soltó o seleccionó un archivo JSON
          setIsNotJson(false);
          setJsonDropped(true);
        } else {
          // Si no es JSON (por ejemplo, un archivo PDF)
          console.log("El archivo no es JSON.");

          // Establecemos los campos en blanco
          setAnaliFecha("");
          setAnaliFechaAnali("");
          setAnaliName("");
          setAnaliSurname("");
          setAnaliBed("");
          setAnaliNhc("");
          setAnaliDni("");
          setAnaliSex("");
          setAnaliOrigen("");
          setAnaliDoctor("");
          setAnaliObs("");
          setAnaliHematiesResult("");
          setAnaliHematiesLow("");
          setAnaliHematiesHigh("");
          setAnaliHemoglobResult("");
          setAnaliHemoglobLow("");
          setAnaliHemoglobHigh("");
          setAnaliHematcrResult("");
          setAnaliHematcrLow("");
          setAnaliHematcrHigh("");
          setAnaliVcmResult("");
          setAnaliVcmLow("");
          setAnaliVcmHigh("");
          setAnaliHcmResult("");
          setAnaliHcmLow("");
          setAnaliHcmHigh("");
          setAnaliChcmResult("");
          setAnaliChcmLow("");
          setAnaliChcmHigh("");
          setAnaliIdhResult("");
          setAnaliIdhLow("");
          setAnaliIdhHigh("");
          setAnaliLeucoResult("");
          setAnaliLeucoLow("");
          setAnaliLeucoHigh("");
          setAnaliNeutrResult("");
          setAnaliNeutrLow("");
          setAnaliNeutrHigh("");
          setAnaliLinfoResult("");
          setAnaliLinfoLow("");
          setAnaliLinfoHigh("");
          setAnaliMonocResult("");
          setAnaliMonocLow("");
          setAnaliMonocHigh("");
          setAnaliEosinResult("");
          setAnaliEosinLow("");
          setAnaliEosinHigh("");
          setAnaliBasofResult("");
          setAnaliBasofLow("");
          setAnaliBasofHigh("");
          setAnaliPlaqResult("");
          setAnaliPlaqLow("");
          setAnaliPlaqHigh("");
          setAnaliPctResult("");
          setAnaliPctLow("");
          setAnaliPctHigh("");
          setAnaliVpmResult("");
          setAnaliVpmLow("");
          setAnaliVpmHigh("");
          setAnaliIdpResult("");
          setAnaliIdpLow("");
          setAnaliIdpHigh("");
          setAnaliTieProtResult("");
          setAnaliTieProtLow("");
          setAnaliTieProtHigh("");
          setAnaliActProtResult("");
          setAnaliActProtLow("");
          setAnaliActProtHigh("");
          setAnaliInrResult("");
          setAnaliInrLow("");
          setAnaliInrHigh("");
          setAnaliGlucResult("");
          setAnaliGlucLow("");
          setAnaliGlucHigh("");
          setAnaliUreaResult("");
          setAnaliUreaLow("");
          setAnaliUreaHigh("");
          setAnaliCreatResult("");
          setAnaliCreatLow("");
          setAnaliCreatHigh("");
          setAnaliGlomResult("");
          setAnaliGlomLow("");
          setAnaliGlomHigh("");
          setAnaliAsparResult("");
          setAnaliAsparLow("");
          setAnaliAsparHigh("");
          setAnaliAlanResult("");
          setAnaliAlanLow("");
          setAnaliAlanHigh("");
          setAnaliGammResult("");
          setAnaliGammLow("");
          setAnaliGammHigh("");
          setAnaliFosfResult("");
          setAnaliFosfLow("");
          setAnaliFosfHigh("");
          setAnaliBiliResult("");
          setAnaliBiliLow("");
          setAnaliBiliHigh("");
          setAnaliColestResult("");
          setAnaliColestLow("");
          setAnaliColestHigh("");
          setAnaliColestHdlResult("");
          setAnaliColestHdlLow("");
          setAnaliColestHdlHigh("");
          setAnaliColestLdlResult("");
          setAnaliColestLdlLow("");
          setAnaliColestLdlHigh("");
          setAnaliTriglResult("");
          setAnaliTriglLow("");
          setAnaliTriglHigh("");
          setAnaliCalcResult("");
          setAnaliCalcLow("");
          setAnaliCalcHigh("");
          setAnaliHierrResult("");
          setAnaliHierrLow("");
          setAnaliHierrHigh("");
          setAnaliSodResult("");
          setAnaliSodLow("");
          setAnaliSodHigh("");
          setAnaliPotasResult("");
          setAnaliPotasLow("");
          setAnaliPotasHigh("");
          setAnaliVitbResult("");
          setAnaliVitbLow("");
          setAnaliVitbHigh("");
          setAnaliVitohResult("");
          setAnaliVitohLow("");
          setAnaliVitohHigh("");
          setAnaliAcidfolResult("");
          setAnaliAcidfolLow("");
          setAnaliAcidfolHigh("");
          setAnaliMagnResult("");
          setAnaliMagnLow("");
          setAnaliMagnHigh("");
          setAnaliFerriResult("");
          setAnaliFerriLow("");
          setAnaliFerriHigh("");
          setAnaliProtcResult("");
          setAnaliProtcLow("");
          setAnaliProtcHigh("");
          setAnaliCortiResult("");
          setAnaliCortiLow("");
          setAnaliCortiHigh("");
          setAnaliDheaResult("");
          setAnaliDheaLow("");
          setAnaliDheaHigh("");
          setAnaliDheaSResult("");
          setAnaliDheaSLow("");
          setAnaliDheaSHigh("");
          setAnaliticaJson("");

          // Marcar que se soltó o seleccionó un archivo PDF
          setIsNotJson(true);
          setJsonDropped(true);
        }
      } catch (error) {
        const jsonErrorFront =
          "Error al analizar el archivo JSON: " + error.message;
        setWarningGeneralMessages((prevMessages) => [
          ...prevMessages,
          jsonErrorFront,
        ]);
        console.log("Error al analizar el archivo JSON:", error);
      }
    };

    // Leer el archivo JSON
      reader.readAsText(file);

  }
  };

  const tryParseJSON = (jsonString) => {
    try {
      return JSON.parse(jsonString);
    } catch (error) {
      return null; // Devuelve null si no se puede analizar como JSON
    }
  };

  // Manejador del evento de arrastre (Drag and drop)
  const onDragOver = (event) => {
    event.preventDefault();
  };

  // Manejador del evento de soltar (Drop)
  const onDrop = (event) => {
    event.preventDefault();

    // Obtener el archivo que se soltó o seleccionó en el navegador
    const droppedFile = event.dataTransfer.files[0] || event.target.files[0];

    // Verificar si el archivo es de tipo PDF
    if (droppedFile && droppedFile.type !== "application/json") {
      // Si no es un archivo JSON, establecer los valores de los inputs como vacíos
      setAnaliFecha("");
      setAnaliFechaAnali("");
      setAnaliName("");
      setAnaliSurname("");
      setAnaliBed("");
      setAnaliNhc("");
      setAnaliDni("");
      setAnaliSex("");
      setAnaliOrigen("");
      setAnaliDoctor("");
      setAnaliObs("");
      setAnaliHematiesResult("");
      setAnaliHematiesLow("");
      setAnaliHematiesHigh("");
      setAnaliHemoglobResult("");
      setAnaliHemoglobLow("");
      setAnaliHemoglobHigh("");
      setAnaliHematcrResult("");
      setAnaliHematcrLow("");
      setAnaliHematcrHigh("");
      setAnaliVcmResult("");
      setAnaliVcmLow("");
      setAnaliVcmHigh("");
      setAnaliHcmResult("");
      setAnaliHcmLow("");
      setAnaliHcmHigh("");
      setAnaliChcmResult("");
      setAnaliChcmLow("");
      setAnaliChcmHigh("");
      setAnaliIdhResult("");
      setAnaliIdhLow("");
      setAnaliIdhHigh("");
      setAnaliLeucoResult("");
      setAnaliLeucoLow("");
      setAnaliLeucoHigh("");
      setAnaliNeutrResult("");
      setAnaliNeutrLow("");
      setAnaliNeutrHigh("");
      setAnaliLinfoResult("");
      setAnaliLinfoLow("");
      setAnaliLinfoHigh("");
      setAnaliMonocResult("");
      setAnaliMonocLow("");
      setAnaliMonocHigh("");
      setAnaliEosinResult("");
      setAnaliEosinLow("");
      setAnaliEosinHigh("");
      setAnaliBasofResult("");
      setAnaliBasofLow("");
      setAnaliBasofHigh("");
      setAnaliPlaqResult("");
      setAnaliPlaqLow("");
      setAnaliPlaqHigh("");
      setAnaliPctResult("");
      setAnaliPctLow("");
      setAnaliPctHigh("");
      setAnaliVpmResult("");
      setAnaliVpmLow("");
      setAnaliVpmHigh("");
      setAnaliIdpResult("");
      setAnaliIdpLow("");
      setAnaliIdpHigh("");
      setAnaliTieProtResult("");
      setAnaliTieProtLow("");
      setAnaliTieProtHigh("");
      setAnaliActProtResult("");
      setAnaliActProtLow("");
      setAnaliActProtHigh("");
      setAnaliInrResult("");
      setAnaliInrLow("");
      setAnaliInrHigh("");
      setAnaliGlucResult("");
      setAnaliGlucLow("");
      setAnaliGlucHigh("");
      setAnaliUreaResult("");
      setAnaliUreaLow("");
      setAnaliUreaHigh("");
      setAnaliCreatResult("");
      setAnaliCreatLow("");
      setAnaliCreatHigh("");
      setAnaliGlomResult("");
      setAnaliGlomLow("");
      setAnaliGlomHigh("");
      setAnaliAsparResult("");
      setAnaliAsparLow("");
      setAnaliAsparHigh("");
      setAnaliAlanResult("");
      setAnaliAlanLow("");
      setAnaliAlanHigh("");
      setAnaliGammResult("");
      setAnaliGammLow("");
      setAnaliGammHigh("");
      setAnaliFosfResult("");
      setAnaliFosfLow("");
      setAnaliFosfHigh("");
      setAnaliBiliResult("");
      setAnaliBiliLow("");
      setAnaliBiliHigh("");
      setAnaliColestResult("");
      setAnaliColestLow("");
      setAnaliColestHigh("");
      setAnaliColestHdlResult("");
      setAnaliColestHdlLow("");
      setAnaliColestHdlHigh("");
      setAnaliColestLdlResult("");
      setAnaliColestLdlLow("");
      setAnaliColestLdlHigh("");
      setAnaliTriglResult("");
      setAnaliTriglLow("");
      setAnaliTriglHigh("");
      setAnaliCalcResult("");
      setAnaliCalcLow("");
      setAnaliCalcHigh("");
      setAnaliHierrResult("");
      setAnaliHierrLow("");
      setAnaliHierrHigh("");
      setAnaliSodResult("");
      setAnaliSodLow("");
      setAnaliSodHigh("");
      setAnaliPotasResult("");
      setAnaliPotasLow("");
      setAnaliPotasHigh("");
      setAnaliVitbResult("");
      setAnaliVitbLow("");
      setAnaliVitbHigh("");
      setAnaliVitohResult("");
      setAnaliVitohLow("");
      setAnaliVitohHigh("");
      setAnaliAcidfolResult("");
      setAnaliAcidfolLow("");
      setAnaliAcidfolHigh("");
      setAnaliMagnResult("");
      setAnaliMagnLow("");
      setAnaliMagnHigh("");
      setAnaliFerriResult("");
      setAnaliFerriLow("");
      setAnaliFerriHigh("");
      setAnaliProtcResult("");
      setAnaliProtcLow("");
      setAnaliProtcHigh("");
      setAnaliCortiResult("");
      setAnaliCortiLow("");
      setAnaliCortiHigh("");
      setAnaliDheaResult("");
      setAnaliDheaLow("");
      setAnaliDheaHigh("");
      setAnaliDheaSResult("");
      setAnaliDheaSLow("");
      setAnaliDheaSHigh("");
      setAnaliticaJson("");

      // Marcar que se soltó o seleccionó un archivo que no es JSON
      setIsNotJson(true);
      setJsonDropped(true);
      processFile(droppedFile);
    } else if (droppedFile && droppedFile.type === "application/json") {
      // Si es un archivo JSON, procesar el archivo utilizando la función de utilidad
      processFile(droppedFile);
      setIsNotJson(false);
      setJsonDropped(true);
    } else {
      console.log(droppedFile);
      // Si es de otro tipo, mostrar un mensaje de advertencia
      setWarningGeneralMessages((prevMessages) => [
        ...prevMessages,
        "El archivo no es ni un archivo JSON ni un otro formato válido.",
      ]);
      console.log(
        "El archivo soltado o seleccionado no es ni un archivo JSON ni otro formato válido."
      );
    }
  };

  return (
    <>
      <div id="content">
        <form id="formNewElement" onSubmit={submitAnaliticas}>
          {/* Área de arrastre */}
          <div
            className="drop-area"
            onDragOver={onDragOver}
            onDrop={onDrop}
            onClick={() => document.getElementById("fileInput").click()}
          >
            Arrastra o selecciona un archivo pdf para introducir datos manualmente.
          </div>

          <input
            id="fileInput"
            type="file"
            accept=".json, .pdf, .doc, .docx, .txt, .jpg, .png, .gif, .jpeg"
            style={{ display: "none" }}
            onChange={(e) => processFile(e.target.files[0])}
          />

          {analiticaIsSecond &&
            (warningGeneralMessages.length > 0 ||
              warningSecondMessages.length > 0) && (
              <div className="warning-message notification is-danger is-light">
                <p>Se han encontrado los siguiente errores:</p>
                <ul>
                  {warningGeneralMessages
                    .concat(warningSecondMessages)
                    .map((message, index) => (
                      <li key={index}>{message}</li>
                    ))}
                </ul>
              </div>
            )}

          {!analiticaIsSecond &&
            (warningMessages.length > 0 ||
              warningGeneralMessages.length > 0) && (
              <div className="warning-message notification is-danger is-light">
                <p>Se han encontrado los siguiente errores:</p>
                <ul>
                  {warningMessages
                    .concat(warningGeneralMessages)
                    .map((message, index) => (
                      <li key={index}>{message}</li>
                    ))}
                </ul>
              </div>
            )}

          {jsonDropped && !isNotJson && (
            <>
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="analiFecha">Fecha visita</label>
                  <div className="control">
                    <input
                      className="input"
                      id="analiFecha"
                      required
                      type="date"
                      value={analiFecha}
                      onChange={(e) => setAnaliFecha(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="analiFechaAnali">Fecha Analítica</label>
                  <div className="control">
                    <input
                      className="input"
                      id="analiFechaAnali"
                      required
                      type="date"
                      value={analiFechaAnali}
                      onChange={(e) => setAnaliFechaAnali(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="analitic-form">
                <h3>Informe del laboratorio</h3>
                <div className="grid--2col">
                  <div className="field">
                    <label htmlFor="analiName">Nombre paciente</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiName"
                        required
                        type="text"
                        value={analiName}
                        onChange={(e) => setAnaliName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiSurname">Apellido paciente</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiSurname"
                        required
                        type="text"
                        value={analiSurname}
                        onChange={(e) => setAnaliSurname(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiDni">DNI</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiDni"
                        required
                        type="text"
                        value={analiDni}
                        onChange={(e) => setAnaliDni(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiNhc">NHC</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiNhc"
                        required
                        type="number"
                        value={analiNhc}
                        onChange={(e) => setAnaliNhc(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiBed">Cama</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiBed"
                        required
                        type="text"
                        value={analiBed}
                        onChange={(e) => setAnaliBed(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiSex">Sexo</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiSex"
                        required
                        type="text"
                        value={analiSex}
                        onChange={(e) => setAnaliSex(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiOrigen">Origen</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiOrigen"
                        required
                        type="text"
                        value={analiOrigen}
                        onChange={(e) => setAnaliOrigen(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiDoctor">Doctor</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiDoctor"
                        required
                        type="text"
                        value={analiDoctor}
                        onChange={(e) => setAnaliDoctor(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiObs">Observaciones</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiObs"
                        type="textarea"
                        value={analiObs}
                        onChange={(e) => setAnaliObs(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {(analiHematiesResult ||
                  analiHemoglobResult ||
                  analiHematcrResult ||
                  analiVcmResult ||
                  analiHcmResult ||
                  analiChcmResult ||
                  analiIdhResult ||
                  analiLeucoResult ||
                  analiNeutrResult ||
                  analiLinfoResult ||
                  analiMonocResult ||
                  analiEosinResult ||
                  analiBasofResult ||
                  analiPlaqResult ||
                  analiPctResult ||
                  analiVpmResult ||
                  analiIdpResult) && (
                  <>
                    <h3>Hematología</h3>
                    <div className="three-col-analitic">
                      {analiHematiesResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Hematies</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiHematiesColor}`}>
                              {analiHematiesResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>6</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiHematiesMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiHematiesMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiHematiesLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiHematiesHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiHemoglobResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Hemoglobina</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiHemoglobColor}`}>
                              {analiHemoglobResult}
                            </p>
                            <p className="anali-units">g/dL</p>
                            <div
                              className={`anali-bar-full ${analiHemoglobMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiHemoglobMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiHemoglobLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiHemoglobHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiHematcrResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Hematocrito</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiHematcrColor}`}>
                              {analiHematcrResult}
                            </p>
                            <p className="anali-units">%</p>
                            <div
                              className={`anali-bar-full ${analiHematcrMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiHematcrMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiHematcrLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiHematcrHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiVcmResult ? (
                        <div className="anali-el">
                          <p className="anali-title">VCM</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiVcmColor}`}>
                              {analiVcmResult}
                            </p>
                            <p className="anali-units">fL</p>
                            <div
                              className={`anali-bar-full ${analiVcmMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiVcmMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiVcmLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiVcmHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiHcmResult ? (
                        <div className="anali-el">
                          <p className="anali-title">HCM</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiHcmColor}`}>
                              {analiHcmResult}
                            </p>
                            <p className="anali-units">pg/cél</p>
                            <div
                              className={`anali-bar-full ${analiHcmMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiHcmMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiHcmLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiHcmHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiChcmResult ? (
                        <div className="anali-el">
                          <p className="anali-title">CHCM</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiChcmColor}`}>
                              {analiChcmResult}
                            </p>
                            <p className="anali-units">g/dL</p>
                            <div
                              className={`anali-bar-full ${analiChcmMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiChcmMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiChcmLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiChcmHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiIdhResult ? (
                        <div className="anali-el">
                          <p className="anali-title">IDH</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiIdhColor}`}>
                              {analiIdhResult}
                            </p>
                            <p className="anali-units">%</p>
                            <div
                              className={`anali-bar-full ${analiIdhMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiIdhMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiIdhLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiIdhHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiLeucoResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Leucocitos</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiLeucoColor}`}>
                              {analiLeucoResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiLeucoMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiLeucoMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiLeucoLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiLeucoHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiNeutrResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Neutrófilos segmentados</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiNeutrColor}`}>
                              {analiNeutrResult}
                            </p>
                            <p className="anali-units"></p>
                            <div
                              className={`anali-bar-full ${analiNeutrMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiNeutrMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiNeutrLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiNeutrHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiLinfoResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Linfocitos</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiLinfoColor}`}>
                              {analiLinfoResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiLinfoMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiLinfoMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiLinfoLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiLinfoHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiMonocResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Monocitos</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiMonocColor}`}>
                              {analiMonocResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiMonocMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiMonocMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiMonocLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiMonocHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiEosinResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Eosinófilos</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiEosinColor}`}>
                              {analiEosinResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiEosinMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiEosinMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiEosinLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiEosinHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiBasofResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Basófilos</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiBasofColor}`}>
                              {analiBasofResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiBasofMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiBasofMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiBasofLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiBasofHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiPlaqResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Plaquetas</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiPlaqColor}`}>
                              {analiPlaqResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiPlaqMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiPlaqMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiPlaqLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiPlaqHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiPctResult ? (
                        <div className="anali-el">
                          <p className="anali-title">PCT</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiPctColor}`}>
                              {analiPctResult}
                            </p>
                            <p className="anali-units">%</p>
                            <div
                              className={`anali-bar-full ${analiPctMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiPctMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiPctLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiPctHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiVpmResult ? (
                        <div className="anali-el">
                          <p className="anali-title">VPM</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiVpmColor}`}>
                              {analiVpmResult}
                            </p>
                            <p className="anali-units">fL</p>
                            <div
                              className={`anali-bar-full ${analiVpmMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiVpmMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiVpmLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiVpmHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiIdpResult ? (
                        <div className="anali-el">
                          <p className="anali-title">IDP</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiIdpColor}`}>
                              {analiIdpResult}
                            </p>
                            <p className="anali-units">%</p>
                            <div
                              className={`anali-bar-full ${analiIdpMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiIdpMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiIdpLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiIdpHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
                {(analiTieProtResult ||
                  analiActProtResult ||
                  analiInrResult) && (
                  <>
                    <h3>Coagulación</h3>

                    <div className="three-col-analitic">
                      {analiTieProtResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Tiempo de Protrombina (seg)
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiTieProtColor}`}>
                              {analiTieProtResult}
                            </p>
                            <p className="anali-units">seg</p>
                            <div
                              className={`anali-bar-full ${analiTieProtMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiTieProtMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiTieProtLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiTieProtHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiActProtResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Actividad de Protrombina (%)
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiActProtColor}`}>
                              {analiActProtResult}
                            </p>
                            <p className="anali-units">%</p>
                            <div
                              className={`anali-bar-full ${analiActProtMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiActProtMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiActProtLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiActProtHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiInrResult ? (
                        <div className="anali-el">
                          <p className="anali-title">INR</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiInrColor}`}>
                              {analiInrResult}
                            </p>
                            <p className="anali-units"></p>
                            <div
                              className={`anali-bar-full ${analiInrMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiInrMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiInrLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiInrHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
                {(analiGlucResult ||
                  analiUreaResult ||
                  analiCreatResult ||
                  analiGlomResult ||
                  analiAsparResult ||
                  analiAlanResult ||
                  analiGammResult ||
                  analiFosfResult ||
                  analiBiliResult ||
                  analiColestResult ||
                  analiColestHdlResult ||
                  analiColestLdlResult ||
                  analiTriglResult ||
                  analiCalcResult ||
                  analiHierrResult ||
                  analiSodResult ||
                  analiPotasResult ||
                  analiVitbResult ||
                  analiVitohResult ||
                  analiAcidfolResult ||
                  analiMagnResult) && (
                  <>
                    <h3>Bioquímica</h3>
                    <div className="three-col-analitic">
                      {analiGlucResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Glucosa, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiGlucColor}`}>
                              {analiGlucResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiGlucMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiGlucMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiGlucLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiGlucHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiUreaResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Urea, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiUreaColor}`}>
                              {analiUreaResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiUreaMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiUreaMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiUreaLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiUreaHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiCreatResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Creatinina, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiCreatColor}`}>
                              {analiCreatResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiCreatMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiCreatMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiCreatLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiCreatHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiGlomResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Filtrado Glomerular CKD-EPI
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiGlomColor}`}>
                              {analiGlomResult}
                            </p>
                            <p className="anali-units">mL/min/1,7</p>
                            <div
                              className={`anali-bar-full ${analiGlomMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiGlomMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiGlomLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiGlomHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiAsparResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Aspartato Amino Transferasa (AST/GOT), Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiAsparColor}`}>
                              {analiAsparResult}
                            </p>
                            <p className="anali-units">U/L</p>
                            <div
                              className={`anali-bar-full ${analiAsparMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiAsparMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiAsparLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiAsparHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiAlanResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Alanina Amino Transferasa (ALT/GPT), Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiAlanColor}`}>
                              {analiAlanResult}
                            </p>
                            <p className="anali-units">U/L</p>
                            <div
                              className={`anali-bar-full ${analiAlanMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiAlanMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiAlanLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiAlanHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiGammResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Gamma Glutamil Transferasa (GGT), Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiGammColor}`}>
                              {analiGammResult}
                            </p>
                            <p className="anali-units">U/L</p>
                            <div
                              className={`anali-bar-full ${analiGammMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiGammMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiGammLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiGammHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiFosfResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Fosfatasa Alcalina (FA), Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiFosfColor}`}>
                              {analiFosfResult}
                            </p>
                            <p className="anali-units">U/L</p>
                            <div
                              className={`anali-bar-full ${analiFosfMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiFosfMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiFosfLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiFosfHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiBiliResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Bilirrubina total, Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiBiliColor}`}>
                              {analiBiliResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiBiliMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiBiliMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiBiliLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiBiliHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiColestResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Colesterol, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiColestColor}`}>
                              {analiColestResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiColestMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiColestMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiColestLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiColestHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiColestHdlResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Colesterol HDL, Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p
                              className={`anali-result ${analiColestHdlColor}`}
                            >
                              {analiColestHdlResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiColestHdlMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiColestHdlMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiColestHdlLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiColestHdlHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiColestLdlResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Colesterol LDL, Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p
                              className={`anali-result ${analiColestLdlColor}`}
                            >
                              {analiColestLdlResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiColestLdlMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiColestLdlMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiColestLdlLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiColestLdlHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiTriglResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Triglicéridos, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiTriglColor}`}>
                              {analiTriglResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiTriglMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiTriglMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiTriglLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiTriglHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiCalcResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Calcio, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiCalcColor}`}>
                              {analiCalcResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiCalcMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiCalcMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiCalcLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiCalcHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiHierrResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Hierro, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiHierrColor}`}>
                              {analiHierrResult}
                            </p>
                            <p className="anali-units">μg/dL</p>
                            <div
                              className={`anali-bar-full ${analiHierrMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiHierrMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiHierrLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiHierrHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiSodResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Sodio, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiSodColor}`}>
                              {analiSodResult}
                            </p>
                            <p className="anali-units">mMol/L</p>
                            <div
                              className={`anali-bar-full ${analiSodMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiSodMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiSodLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiSodHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiPotasResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Potasio, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiPotasColor}`}>
                              {analiPotasResult}
                            </p>
                            <p className="anali-units">mMol/L</p>
                            <div
                              className={`anali-bar-full ${analiPotasMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiPotasMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiPotasLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiPotasHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiVitbResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Vitamina B12, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiVitbColor}`}>
                              {analiVitbResult}
                            </p>
                            <p className="anali-units">pg/mL</p>
                            <div
                              className={`anali-bar-full ${analiVitbMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiVitbMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiVitbLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiVitbHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiVitohResult ? (
                        <div className="anali-el">
                          <p className="anali-title">25-OH Vitamina D</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiVitohColor}`}>
                              {analiVitohResult}
                            </p>
                            <p className="anali-units">ng/mL</p>
                            <div
                              className={`anali-bar-full ${analiVitohMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiVitohMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiVitohLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiVitohHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiAcidfolResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Acido Folico Folato, Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiAcidfolColor}`}>
                              {analiAcidfolResult}
                            </p>
                            <p className="anali-units">ng/mL</p>
                            <div
                              className={`anali-bar-full ${analiAcidfolMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiAcidfolMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiAcidfolLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiAcidfolHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiMagnResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Magnesio, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiMagnColor}`}>
                              {analiMagnResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiMagnMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiMagnMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiMagnLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiMagnHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
                {(analiFerriResult || analiProtcResult) && (
                  <>
                    <h3>Proteínas</h3>
                    <div className="three-col-analitic">
                      {analiFerriResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Ferritina, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiFerriColor}`}>
                              {analiFerriResult}
                            </p>
                            <p className="anali-units">ng/mL</p>
                            <div
                              className={`anali-bar-full ${analiFerriMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiFerriMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiFerriLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiFerriHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiProtcResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Proteína C Reactiva (PCR), Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiProtcColor}`}>
                              {analiProtcResult}
                            </p>
                            <p className="anali-units">mg/L</p>
                            <div
                              className={`anali-bar-full ${analiProtcMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiProtcMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiProtcLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiProtcHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
                {analiticaIsSecond && (
                  <>
                    <h3>Analitica B</h3>
                    <div className="three-col-analitic">
                      {analiCortiResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Cortisol</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiCortiColor}`}>
                              {analiCortiResult}
                            </p>
                            <p className="anali-units">g/dL</p>
                            <div
                              className={`anali-bar-full ${analiCortiMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiCortiMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiCortiLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiCortiHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiDheaResult ? (
                        <div className="anali-el">
                          <p className="anali-title">DHEA</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiDheaColor}`}>
                              {analiDheaResult}
                            </p>
                            <p className="anali-units">ng/mL</p>
                            <div
                              className={`anali-bar-full ${analiDheaMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiDheaMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiDheaLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiDheaHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiDheaSResult ? (
                        <div className="anali-el">
                          <p className="anali-title">DHEA-S</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiDheaSColor}`}>
                              {analiDheaSResult}
                            </p>
                            <p className="anali-units">g/mL</p>
                            <div
                              className={`anali-bar-full ${analiDheaSMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiDheaSMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiDheaSLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiDheaSHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
              </div>
            </>
          )}
          {jsonDropped && isNotJson && (
            <>
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="analiFecha">Fecha visita</label>
                  <div className="control">
                    <input
                      className="input"
                      id="analiFecha"
                      required
                      type="date"
                      value={analiFecha}
                      onChange={(e) => setAnaliFecha(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="analiFechaAnali">Fecha Analítica</label>
                  <div className="control">
                    <input
                      className="input"
                      id="analiFechaAnali"
                      required
                      type="date"
                      value={analiFechaAnali}
                      onChange={(e) => setAnaliFechaAnali(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="analitic-form">
                <h3>Informe del laboratorio</h3>
                <div className="grid--2col">
                  <div className="field">
                    <label htmlFor="analiName">Nombre paciente</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiName"
                        required
                        type="text"
                        value={analiName}
                        onChange={(e) => setAnaliName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiSurname">Apellido paciente</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiSurname"
                        required
                        type="text"
                        value={analiSurname}
                        onChange={(e) => setAnaliSurname(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiDni">DNI</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiDni"
                        required
                        type="text"
                        value={analiDni}
                        onChange={(e) => setAnaliDni(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiNhc">NHC</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiNhc"
                        required
                        type="number"
                        value={analiNhc}
                        onChange={(e) => setAnaliNhc(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiBed">Cama</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiBed"
                        required
                        type="text"
                        value={analiBed}
                        onChange={(e) => setAnaliBed(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiSex">Sexo</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiSex"
                        required
                        type="text"
                        value={analiSex}
                        onChange={(e) => setAnaliSex(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiOrigen">Origen</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiOrigen"
                        required
                        type="text"
                        value={analiOrigen}
                        onChange={(e) => setAnaliOrigen(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiDoctor">Doctor</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiDoctor"
                        required
                        type="text"
                        value={analiDoctor}
                        onChange={(e) => setAnaliDoctor(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="analiObs">Observaciones</label>
                    <div className="control">
                      <input
                        className="input"
                        id="analiObs"
                        type="textarea"
                        value={analiObs}
                        onChange={(e) => setAnaliObs(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <h3>Hematología</h3>
                <div className="grid--4col">
                  {/* Hematies empty field  */}
                  <div className="field">
                    <h4>
                      Hematies{" "}
                      <i>
                        (x10<sup>6</sup>/μL)
                      </i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHematiesResult"
                        type="number"
                        value={analiHematiesResult}
                        onChange={(e) => setAnaliHematiesResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHematiesLow"
                        type="number"
                        value={analiHematiesLow}
                        onChange={(e) => setAnaliHematiesLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHematiesHigh"
                        type="number"
                        value={analiHematiesHigh}
                        onChange={(e) => setAnaliHematiesHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Hemoglobina empty field  */}
                  <div className="field">
                    <h4>
                      Hemoglobina <i>(g/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHemoglobResult"
                        type="number"
                        value={analiHemoglobResult}
                        onChange={(e) => setAnaliHemoglobResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHemoglobLow"
                        type="number"
                        value={analiHemoglobLow}
                        onChange={(e) => setAnaliHemoglobLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHemoglobHigh"
                        type="number"
                        value={analiHemoglobHigh}
                        onChange={(e) => setAnaliHemoglobHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Hematocrito empty field  */}
                  <div className="field">
                    <h4>
                      Hematocrito <i>(%)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHematcrResult"
                        type="number"
                        value={analiHematcrResult}
                        onChange={(e) => setAnaliHematcrResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHematcrLow"
                        type="number"
                        value={analiHematcrLow}
                        onChange={(e) => setAnaliHematcrLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHematcrHigh"
                        type="number"
                        value={analiHematcrHigh}
                        onChange={(e) => setAnaliHematcrHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* VCM empty field  */}
                  <div className="field">
                    <h4>
                      VCM <i>(fL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVcmResult"
                        type="number"
                        value={analiVcmResult}
                        onChange={(e) => setAnaliVcmResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVcmLow"
                        type="number"
                        value={analiVcmLow}
                        onChange={(e) => setAnaliVcmLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVcmHigh"
                        type="number"
                        value={analiVcmHigh}
                        onChange={(e) => setAnaliVcmHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* HCM empty field  */}
                  <div className="field">
                    <h4>
                      HCM <i>(pg/cél)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHcmResult"
                        type="number"
                        value={analiHcmResult}
                        onChange={(e) => setAnaliHcmResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHcmLow"
                        type="number"
                        value={analiHcmLow}
                        onChange={(e) => setAnaliHcmLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHcmHigh"
                        type="number"
                        value={analiHcmHigh}
                        onChange={(e) => setAnaliHcmHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* CHCM empty field  */}
                  <div className="field">
                    <h4>
                      CHCM <i>(g/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiChcmResult"
                        type="number"
                        value={analiChcmResult}
                        onChange={(e) => setAnaliChcmResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiChcmLow"
                        type="number"
                        value={analiChcmLow}
                        onChange={(e) => setAnaliChcmLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiChcmHigh"
                        type="number"
                        value={analiChcmHigh}
                        onChange={(e) => setAnaliChcmHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* IDH empty field  */}
                  <div className="field">
                    <h4>
                      IDH <i>(%)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiIdhResult"
                        type="number"
                        value={analiIdhResult}
                        onChange={(e) => setAnaliIdhResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiIdhLow"
                        type="number"
                        value={analiIdhLow}
                        onChange={(e) => setAnaliIdhLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiIdhHigh"
                        type="number"
                        value={analiIdhHigh}
                        onChange={(e) => setAnaliIdhHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>

                  {/* Hematies empty field  */}
                  <div className="field">
                    <h4>
                      Leucocitos{" "}
                      <i>
                        (x10<sup>3</sup>/μL)
                      </i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiLeucoResult"
                        type="number"
                        value={analiLeucoResult}
                        onChange={(e) => setAnaliLeucoResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiLeucoLow"
                        type="number"
                        value={analiLeucoLow}
                        onChange={(e) => setAnaliLeucoLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiLeucoHigh"
                        type="number"
                        value={analiLeucoHigh}
                        onChange={(e) => setAnaliLeucoHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Neutrófilos segmentados empty field  */}
                  <div className="field">
                    <h4>
                      Neutrófilos segmentados{" "}
                      <i>
                        (x10<sup>3</sup>/μL)
                      </i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiNeutrResult"
                        type="number"
                        value={analiNeutrResult}
                        onChange={(e) => setAnaliNeutrResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiNeutrLow"
                        type="number"
                        value={analiNeutrLow}
                        onChange={(e) => setAnaliNeutrLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiNeutrHigh"
                        type="number"
                        value={analiNeutrHigh}
                        onChange={(e) => setAnaliNeutrHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Linfocitos empty field  */}
                  <div className="field">
                    <h4>
                      Linfocitos{" "}
                      <i>
                        (x10<sup>3</sup>/μL)
                      </i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiLinfoResult"
                        type="number"
                        value={analiLinfoResult}
                        onChange={(e) => setAnaliLinfoResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiLinfoLow"
                        type="number"
                        value={analiLinfoLow}
                        onChange={(e) => setAnaliLinfoLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiLinfoHigh"
                        type="number"
                        value={analiLinfoHigh}
                        onChange={(e) => setAnaliLinfoHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Monocitos empty field  */}
                  <div className="field">
                    <h4>
                      Monocitos{" "}
                      <i>
                        (x10<sup>3</sup>/μL)
                      </i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiMonocResult"
                        type="number"
                        value={analiMonocResult}
                        onChange={(e) => setAnaliMonocResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiMonocLow"
                        type="number"
                        value={analiMonocLow}
                        onChange={(e) => setAnaliMonocLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiMonocHigh"
                        type="number"
                        value={analiMonocHigh}
                        onChange={(e) => setAnaliMonocHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Eosinófilos empty field  */}
                  <div className="field">
                    <h4>
                      Eosinófilos{" "}
                      <i>
                        (x10<sup>3</sup>/μL)
                      </i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiEosinResult"
                        type="number"
                        value={analiEosinResult}
                        onChange={(e) => setAnaliEosinResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiEosinLow"
                        type="number"
                        value={analiEosinLow}
                        onChange={(e) => setAnaliEosinLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiEosinHigh"
                        type="number"
                        value={analiEosinHigh}
                        onChange={(e) => setAnaliEosinHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Basófilos empty field  */}
                  <div className="field">
                    <h4>
                      Basófilos{" "}
                      <i>
                        (x10<sup>3</sup>/μL)
                      </i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiBasofResult"
                        type="number"
                        value={analiBasofResult}
                        onChange={(e) => setAnaliBasofResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiBasofLow"
                        type="number"
                        value={analiBasofLow}
                        onChange={(e) => setAnaliBasofLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiBasofHigh"
                        type="number"
                        value={analiBasofHigh}
                        onChange={(e) => setAnaliBasofHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Plaquetas empty field  */}
                  <div className="field">
                    <h4>
                      Plaquetas{" "}
                      <i>
                        (x10<sup>3</sup>/μL)
                      </i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiPlaqResult"
                        type="number"
                        value={analiPlaqResult}
                        onChange={(e) => setAnaliPlaqResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiPlaqLow"
                        type="number"
                        value={analiPlaqLow}
                        onChange={(e) => setAnaliPlaqLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiPlaqHigh"
                        type="number"
                        value={analiPlaqHigh}
                        onChange={(e) => setAnaliPlaqHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* PCT empty field  */}
                  <div className="field">
                    <h4>
                      PCT <i>(%)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiPctResult"
                        type="number"
                        value={analiPctResult}
                        onChange={(e) => setAnaliPctResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiPctLow"
                        type="number"
                        value={analiPctLow}
                        onChange={(e) => setAnaliPctLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiPctHigh"
                        type="number"
                        value={analiPctHigh}
                        onChange={(e) => setAnaliPctHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* VPM empty field  */}
                  <div className="field">
                    <h4>
                      VPM <i>(fL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVpmResult"
                        type="number"
                        value={analiVpmResult}
                        onChange={(e) => setAnaliVpmResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVpmLow"
                        type="number"
                        value={analiVpmLow}
                        onChange={(e) => setAnaliVpmLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVpmHigh"
                        type="number"
                        value={analiVpmHigh}
                        onChange={(e) => setAnaliVpmHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* IDP empty field  */}
                  <div className="field">
                    <h4>
                      IDP <i>(%)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiIdpResult"
                        type="number"
                        value={analiIdpResult}
                        onChange={(e) => setAnaliIdpResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiIdpLow"
                        type="number"
                        value={analiIdpLow}
                        onChange={(e) => setAnaliIdpLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiIdpHigh"
                        type="number"
                        value={analiIdpHigh}
                        onChange={(e) => setAnaliIdpHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                </div>
                <h3>Coagulación</h3>
                <div className="grid--4col">
                  {/* Tiempo de Protrombina empty field  */}
                  <div className="field">
                    <h4>
                      Tiempo de Protrombina <i>(seg)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiTieProtResult"
                        type="number"
                        value={analiTieProtResult}
                        onChange={(e) => setAnaliTieProtResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiTieProtLow"
                        type="number"
                        value={analiTieProtLow}
                        onChange={(e) => setAnaliTieProtLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiTieProtHigh"
                        type="number"
                        value={analiTieProtHigh}
                        onChange={(e) => setAnaliTieProtHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Actividad de Protrombina empty field  */}
                  <div className="field">
                    <h4>
                      Actividad de Protrombina <i>(%)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiActProtResult"
                        type="number"
                        value={analiActProtResult}
                        onChange={(e) => setAnaliActProtResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiActProtLow"
                        type="number"
                        value={analiActProtLow}
                        onChange={(e) => setAnaliActProtLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiActProtHigh"
                        type="number"
                        value={analiActProtHigh}
                        onChange={(e) => setAnaliActProtHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* INR empty field  */}
                  <div className="field">
                    <h4>INR </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiInrResult"
                        type="number"
                        value={analiInrResult}
                        onChange={(e) => setAnaliInrResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiInrLow"
                        type="number"
                        value={analiInrLow}
                        onChange={(e) => setAnaliInrLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiInrHigh"
                        type="number"
                        value={analiInrHigh}
                        onChange={(e) => setAnaliInrHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                </div>
                <h3>Bioquímica</h3>
                <div className="grid--4col">
                  {/* Glucosa, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Glucosa, Suero/Pl{" "}
                      <i>
                        (x10<sup>6</sup>/μL)
                      </i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiGlucResult"
                        type="number"
                        value={analiGlucResult}
                        onChange={(e) => setAnaliGlucResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiGlucLow"
                        type="number"
                        value={analiGlucLow}
                        onChange={(e) => setAnaliGlucLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiGlucHigh"
                        type="number"
                        value={analiGlucHigh}
                        onChange={(e) => setAnaliGlucHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Urea, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Urea, Suero/Pl <i>(mg/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiUreaResult"
                        type="number"
                        value={analiUreaResult}
                        onChange={(e) => setAnaliUreaResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiUreaLow"
                        type="number"
                        value={analiUreaLow}
                        onChange={(e) => setAnaliUreaLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiUreaHigh"
                        type="number"
                        value={analiUreaHigh}
                        onChange={(e) => setAnaliUreaHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Creatinina, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Creatinina, Suero/Pl <i>(mg/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiCreatResult"
                        type="number"
                        value={analiCreatResult}
                        onChange={(e) => setAnaliCreatResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiCreatLow"
                        type="number"
                        value={analiCreatLow}
                        onChange={(e) => setAnaliCreatLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiCreatHigh"
                        type="number"
                        value={analiCreatHigh}
                        onChange={(e) => setAnaliCreatHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Filtrado Glomerular CKD-EPI empty field  */}
                  <div className="field">
                    <h4>
                      Filtrado Glomerular CKD-EPI <i>(mL/min/1,7)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiGlomResult"
                        type="number"
                        value={analiGlomResult}
                        onChange={(e) => setAnaliGlomResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiGlomLow"
                        type="number"
                        value={analiGlomLow}
                        onChange={(e) => setAnaliGlomLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiGlomHigh"
                        type="number"
                        value={analiGlomHigh}
                        onChange={(e) => setAnaliGlomHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Aspartato Amino Transferasa empty field  */}
                  <div className="field">
                    <h4>
                      Aspartato Amino Transferasa (AST/GOT), Suero/Pl{" "}
                      <i>(U/L)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiAsparResult"
                        type="number"
                        value={analiAsparResult}
                        onChange={(e) => setAnaliAsparResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiAsparLow"
                        type="number"
                        value={analiAsparLow}
                        onChange={(e) => setAnaliAsparLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiAsparHigh"
                        type="number"
                        value={analiAsparHigh}
                        onChange={(e) => setAnaliAsparHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Alanina Amino Transferasa empty field  */}
                  <div className="field">
                    <h4>
                      Alanina Amino Transferasa (ALT/GPT), Suero/Pl <i>(U/L)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiAlanResult"
                        type="number"
                        value={analiAlanResult}
                        onChange={(e) => setAnaliAlanResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiAlanLow"
                        type="number"
                        value={analiAlanLow}
                        onChange={(e) => setAnaliAlanLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiAlanHigh"
                        type="number"
                        value={analiAlanHigh}
                        onChange={(e) => setAnaliAlanHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Gamma Glutamil Transferasa empty field  */}
                  <div className="field">
                    <h4>
                      Gamma Glutamil Transferasa (GGT), Suero/Pl <i>(U/L)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiGammResult"
                        type="number"
                        value={analiGammResult}
                        onChange={(e) => setAnaliGammResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiGammLow"
                        type="number"
                        value={analiGammLow}
                        onChange={(e) => setAnaliGammLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiGammHigh"
                        type="number"
                        value={analiGammHigh}
                        onChange={(e) => setAnaliGammHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Fosfatasa Alcalina (FA) empty field  */}
                  <div className="field">
                    <h4>
                      Fosfatasa Alcalina (FA), Suero/Pl <i>(U/L)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiFosfResult"
                        type="number"
                        value={analiFosfResult}
                        onChange={(e) => setAnaliFosfResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiFosfLow"
                        type="number"
                        value={analiFosfLow}
                        onChange={(e) => setAnaliFosfLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiFosfHigh"
                        type="number"
                        value={analiFosfHigh}
                        onChange={(e) => setAnaliFosfHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Bilirrubina total, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Bilirrubina total, Suero/Pl <i>(mg/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiBiliResult"
                        type="number"
                        value={analiBiliResult}
                        onChange={(e) => setAnaliBiliResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiBiliLow"
                        type="number"
                        value={analiBiliLow}
                        onChange={(e) => setAnaliBiliLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiBiliHigh"
                        type="number"
                        value={analiBiliHigh}
                        onChange={(e) => setAnaliBiliHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Colesterol, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Colesterol, Suero/Pl <i>(mg/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiColestResult"
                        type="number"
                        value={analiColestResult}
                        onChange={(e) => setAnaliColestResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiColestLow"
                        type="number"
                        value={analiColestLow}
                        onChange={(e) => setAnaliColestLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiColestHigh"
                        type="number"
                        value={analiColestHigh}
                        onChange={(e) => setAnaliColestHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Colesterol HDL, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Colesterol HDL, Suero/Pl <i>(mg/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiColestHdlResult"
                        type="number"
                        value={analiColestHdlResult}
                        onChange={(e) =>
                          setAnaliColestHdlResult(e.target.value)
                        }
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiColestHdlLow"
                        type="number"
                        value={analiColestHdlLow}
                        onChange={(e) => setAnaliColestHdlLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiColestHdlHigh"
                        type="number"
                        value={analiColestHdlHigh}
                        onChange={(e) => setAnaliColestHdlHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Colesterol LDL, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Colesterol LDL, Suero/Pl <i>(mg/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiColestLdlResult"
                        type="number"
                        value={analiColestLdlResult}
                        onChange={(e) =>
                          setAnaliColestLdlResult(e.target.value)
                        }
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiColestLdlLow"
                        type="number"
                        value={analiColestLdlLow}
                        onChange={(e) => setAnaliColestLdlLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiColestLdlHigh"
                        type="number"
                        value={analiColestLdlHigh}
                        onChange={(e) => setAnaliColestLdlHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Triglicéridos, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Triglicéridos, Suero/Pl <i>(mg/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiTriglResult"
                        type="number"
                        value={analiTriglResult}
                        onChange={(e) => setAnaliTriglResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiTriglLow"
                        type="number"
                        value={analiTriglLow}
                        onChange={(e) => setAnaliTriglLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiTriglHigh"
                        type="number"
                        value={analiTriglHigh}
                        onChange={(e) => setAnaliTriglHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Calcio, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Calcio, Suero/Pl <i>(mg/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiCalcResult"
                        type="number"
                        value={analiCalcResult}
                        onChange={(e) => setAnaliCalcResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiCalcLow"
                        type="number"
                        value={analiCalcLow}
                        onChange={(e) => setAnaliCalcLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiCalcHigh"
                        type="number"
                        value={analiCalcHigh}
                        onChange={(e) => setAnaliCalcHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Hierro, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Hierro, Suero/Pl <i>(μg/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHierrResult"
                        type="number"
                        value={analiHierrResult}
                        onChange={(e) => setAnaliHierrResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHierrLow"
                        type="number"
                        value={analiHierrLow}
                        onChange={(e) => setAnaliHierrLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiHierrHigh"
                        type="number"
                        value={analiHierrHigh}
                        onChange={(e) => setAnaliHierrHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Sodio, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Sodio, Suero/Pl <i>(mMol/L)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiSodResult"
                        type="number"
                        value={analiSodResult}
                        onChange={(e) => setAnaliSodResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiSodLow"
                        type="number"
                        value={analiSodLow}
                        onChange={(e) => setAnaliSodLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiSodHigh"
                        type="number"
                        value={analiSodHigh}
                        onChange={(e) => setAnaliSodHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Potasio, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Potasio, Suero/Pl <i>(mMol/L)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiPotasResult"
                        type="number"
                        value={analiPotasResult}
                        onChange={(e) => setAnaliPotasResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiPotasLow"
                        type="number"
                        value={analiPotasLow}
                        onChange={(e) => setAnaliPotasLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiPotasHigh"
                        type="number"
                        value={analiPotasHigh}
                        onChange={(e) => setAnaliPotasHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Vitamina B12, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Vitamina B12, Suero/Pl <i>(pg/mL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVitbResult"
                        type="number"
                        value={analiVitbResult}
                        onChange={(e) => setAnaliVitbResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVitbLow"
                        type="number"
                        value={analiVitbLow}
                        onChange={(e) => setAnaliVitbLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVitbHigh"
                        type="number"
                        value={analiVitbHigh}
                        onChange={(e) => setAnaliVitbHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* 25-OH Vitamina D empty field  */}
                  <div className="field">
                    <h4>
                      25-OH Vitamina D <i>(ng/mL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVitohResult"
                        type="number"
                        value={analiVitohResult}
                        onChange={(e) => setAnaliVitohResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVitohLow"
                        type="number"
                        value={analiVitohLow}
                        onChange={(e) => setAnaliVitohLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiVitohHigh"
                        type="number"
                        value={analiVitohHigh}
                        onChange={(e) => setAnaliVitohHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Acido Folico Folato, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Acido Folico Folato, Suero/Pl <i>(ng/mL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiAcidfolResult"
                        type="number"
                        value={analiAcidfolResult}
                        onChange={(e) => setAnaliAcidfolResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiAcidfolLow"
                        type="number"
                        value={analiAcidfolLow}
                        onChange={(e) => setAnaliAcidfolLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiAcidfolHigh"
                        type="number"
                        value={analiAcidfolHigh}
                        onChange={(e) => setAnaliAcidfolHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Magnesio, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Magnesio, Suero/Pl <i>(mg/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiMagnResult"
                        type="number"
                        value={analiMagnResult}
                        onChange={(e) => setAnaliMagnResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiMagnLow"
                        type="number"
                        value={analiMagnLow}
                        onChange={(e) => setAnaliMagnLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiMagnHigh"
                        type="number"
                        value={analiMagnHigh}
                        onChange={(e) => setAnaliMagnHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                </div>
                <h3>Proteínas</h3>
                <div className="grid--4col">
                  {/* Ferritina, Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Ferritina, Suero/Pl <i>(ng/mL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiFerriResult"
                        type="number"
                        value={analiFerriResult}
                        onChange={(e) => setAnaliFerriResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiFerriLow"
                        type="number"
                        value={analiFerriLow}
                        onChange={(e) => setAnaliFerriLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiFerriHigh"
                        type="number"
                        value={analiFerriHigh}
                        onChange={(e) => setAnaliFerriHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* Proteína C Reactiva (PCR), Suero/Pl empty field  */}
                  <div className="field">
                    <h4>
                      Proteína C Reactiva (PCR), Suero/Pl <i>(mg/L)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiProtcResult"
                        type="number"
                        value={analiProtcResult}
                        onChange={(e) => setAnaliProtcResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiProtcLow"
                        type="number"
                        value={analiProtcLow}
                        onChange={(e) => setAnaliProtcLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiProtcHigh"
                        type="number"
                        value={analiProtcHigh}
                        onChange={(e) => setAnaliProtcHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                </div>
                <h3>Analitica B</h3>
                <div className="grid--4col">
                  {/* Cortisol empty field  */}
                  <div className="field">
                    <h4>
                      Cortisol <i>(g/dL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiCortiResult"
                        type="number"
                        value={analiCortiResult}
                        onChange={(e) => setAnaliCortiResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiCortiLow"
                        type="number"
                        value={analiCortiLow}
                        onChange={(e) => setAnaliCortiLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiCortiHigh"
                        type="number"
                        value={analiCortiHigh}
                        onChange={(e) => setAnaliCortiHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* DHEA empty field  */}
                  <div className="field">
                    <h4>
                      DHEA <i>(ng/mL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiDheaResult"
                        type="number"
                        value={analiDheaResult}
                        onChange={(e) => setAnaliDheaResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiDheaLow"
                        type="number"
                        value={analiDheaLow}
                        onChange={(e) => setAnaliDheaLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiDheaHigh"
                        type="number"
                        value={analiDheaHigh}
                        onChange={(e) => setAnaliDheaHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                  {/* DHEA-S empty field  */}
                  <div className="field">
                    <h4>
                      DHEA-S <i>(g/mL)</i>
                    </h4>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiDheaSResult"
                        type="number"
                        value={analiDheaSResult}
                        onChange={(e) => setAnaliDheaSResult(e.target.value)}
                        placeholder="Resultado"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiDheaSLow"
                        type="number"
                        value={analiDheaSLow}
                        onChange={(e) => setAnaliDheaSLow(e.target.value)}
                        placeholder="Valor mínimo"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input"
                        id="analiDheaSHigh"
                        type="number"
                        value={analiDheaSHigh}
                        onChange={(e) => setAnaliDheaSHigh(e.target.value)}
                        placeholder="Valor máximo"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </form>
      </div>
      <div id="actions">
        <button 
        className="button is-link" 
        form="formNewElement" 
        type="submit"
        disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
      </div>
    </>
  );
}
